// Static data for offline mode - Auto-generated
// This file contains all stores and coupons data

export const STORES_DATA = [
  {
    "id": "62711996-ee12-430b-9c67-44267ca247bc",
    "name": "Nike",
    "domain": "nike.com",
    "logo": "https://www.google.com/s2/favicons?domain=nike.com&sz=128",
    "description": "Athletic footwear, apparel, and equipment",
    "featured": true,
    "total_coupons": 7,
    "created_at": "2025-12-11T10:17:04.864000"
  },
  {
    "id": "14f03419-f0ba-4fae-970f-e151f0423419",
    "name": "Amazon",
    "domain": "amazon.com",
    "logo": "https://www.google.com/s2/favicons?domain=amazon.com&sz=128",
    "description": "Online shopping for everything",
    "featured": true,
    "total_coupons": 5,
    "created_at": "2025-12-11T10:17:04.879000"
  },
  {
    "id": "033c7eec-28fc-48a2-bd09-667f201df9fb",
    "name": "Adidas",
    "domain": "adidas.com",
    "logo": "https://www.google.com/s2/favicons?domain=adidas.com&sz=128",
    "description": "Sports clothing and accessories",
    "featured": true,
    "total_coupons": 5,
    "created_at": "2025-12-11T10:17:04.879000"
  },
  {
    "id": "bc937020-1603-4447-9f78-ae56f9ad75cb",
    "name": "Macy's",
    "domain": "macys.com",
    "logo": "https://www.google.com/s2/favicons?domain=macys.com&sz=128",
    "description": "Department store for fashion and home",
    "featured": true,
    "total_coupons": 6,
    "created_at": "2025-12-11T10:17:04.879000"
  },
  {
    "id": "eb7aa46d-aae7-4071-86bf-af284995647e",
    "name": "Target",
    "domain": "target.com",
    "logo": "https://www.google.com/s2/favicons?domain=target.com&sz=128",
    "description": "Everyday essentials and more",
    "featured": true,
    "total_coupons": 6,
    "created_at": "2025-12-11T10:17:04.880000"
  },
  {
    "id": "51b3aa89-74b9-4a29-b842-7a215e15cb79",
    "name": "Walmart",
    "domain": "walmart.com",
    "logo": "https://www.google.com/s2/favicons?domain=walmart.com&sz=128",
    "description": "Save money, live better",
    "featured": true,
    "total_coupons": 6,
    "created_at": "2025-12-11T10:17:04.880000"
  },
  {
    "id": "275a202a-54a2-43c1-8fd6-192642273a55",
    "name": "Nordstrom Rack",
    "domain": "nordstromrack.com",
    "logo": "https://www.google.com/s2/favicons?domain=nordstromrack.com&sz=128",
    "description": "Designer brands at discount prices",
    "featured": true,
    "total_coupons": 8,
    "created_at": "2025-12-11T10:17:04.880000"
  },
  {
    "id": "2c90d993-26e4-4f71-bc19-b3d487570dc2",
    "name": "Kohl's",
    "domain": "kohls.com",
    "logo": "https://www.google.com/s2/favicons?domain=kohls.com&sz=128",
    "description": "Department store savings",
    "featured": true,
    "total_coupons": 7,
    "created_at": "2025-12-11T10:17:04.880000"
  },
  {
    "id": "e75a01d1-6989-462c-a861-53d404b70656",
    "name": "Best Buy",
    "domain": "bestbuy.com",
    "logo": "https://www.google.com/s2/favicons?domain=bestbuy.com&sz=128",
    "description": "Electronics and appliances",
    "featured": false,
    "total_coupons": 7,
    "created_at": "2025-12-11T10:17:04.881000"
  },
  {
    "id": "aec86b07-805d-4070-9d54-00e2aaf105b9",
    "name": "Sephora",
    "domain": "sephora.com",
    "logo": "https://www.google.com/s2/favicons?domain=sephora.com&sz=128",
    "description": "Beauty and cosmetics",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T10:17:04.881000"
  },
  {
    "id": "228d61ef-2327-4d6a-a7fa-2b59a7dc7b0f",
    "name": "Old Navy",
    "domain": "oldnavy.com",
    "logo": "https://www.google.com/s2/favicons?domain=oldnavy.com&sz=128",
    "description": "Affordable fashion for the family",
    "featured": false,
    "total_coupons": 6,
    "created_at": "2025-12-11T10:17:04.881000"
  },
  {
    "id": "0909f958-443c-4280-90ec-96503185f4d9",
    "name": "Under Armour",
    "domain": "underarmour.com",
    "logo": "https://www.google.com/s2/favicons?domain=underarmour.com&sz=128",
    "description": "Performance athletic gear",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T10:17:04.881000"
  },
  {
    "id": "1db189ed-7203-463d-afcd-b4d70a45e40d",
    "name": "Wayfair",
    "domain": "wayfair.com",
    "logo": "https://www.google.com/s2/favicons?domain=wayfair.com&sz=128",
    "description": "Furniture and home decor",
    "featured": false,
    "total_coupons": 7,
    "created_at": "2025-12-11T10:17:04.881000"
  },
  {
    "id": "0ee3915c-cc47-48cc-817b-cc088f340294",
    "name": "Gap",
    "domain": "gap.com",
    "logo": "https://www.google.com/s2/favicons?domain=gap.com&sz=128",
    "description": "Casual clothing and accessories",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T10:17:04.881000"
  },
  {
    "id": "dffc8586-281a-4b6b-9569-6df6aa53a093",
    "name": "Forever 21",
    "domain": "forever21.com",
    "logo": "https://www.google.com/s2/favicons?domain=forever21.com&sz=128",
    "description": "Trendy fashion",
    "featured": false,
    "total_coupons": 8,
    "created_at": "2025-12-11T10:17:04.882000"
  },
  {
    "id": "a8904b02-da76-4da6-b455-d8789318f913",
    "name": "Expedia",
    "domain": "expedia.com",
    "logo": "https://www.google.com/s2/favicons?domain=expedia.com&sz=128",
    "description": "Travel bookings and deals",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T10:17:04.882000"
  },
  {
    "id": "a8d92aa7-0ebc-4ae5-b395-2565636bcbc5",
    "name": "Hotels.com",
    "domain": "hotels.com",
    "logo": "https://www.google.com/s2/favicons?domain=hotels.com&sz=128",
    "description": "Hotel reservations worldwide",
    "featured": false,
    "total_coupons": 6,
    "created_at": "2025-12-11T10:17:04.882000"
  },
  {
    "id": "04725598-0f5e-43c4-bd14-4fea9a30db91",
    "name": "GoDaddy",
    "domain": "godaddy.com",
    "logo": "https://www.google.com/s2/favicons?domain=godaddy.com&sz=128",
    "description": "Domain registration and hosting",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T10:17:04.882000"
  },
  {
    "id": "818943b8-e777-4a6d-949d-dc5f0aa7597a",
    "name": "H&M",
    "domain": "hm.com",
    "logo": "https://www.google.com/s2/favicons?domain=hm.com&sz=128",
    "description": "Trendy fashion and clothing for all",
    "featured": true,
    "total_coupons": 7,
    "created_at": "2025-12-11T10:45:32.839000"
  },
  {
    "id": "80a88086-37ba-4571-8a36-09e0d467bff9",
    "name": "Zara",
    "domain": "zara.com",
    "logo": "https://www.google.com/s2/favicons?domain=zara.com&sz=128",
    "description": "Fast fashion from Spain",
    "featured": true,
    "total_coupons": 6,
    "created_at": "2025-12-11T10:45:32.842000"
  },
  {
    "id": "6f95cfc6-7716-4cb3-b165-de83837e72f5",
    "name": "Uniqlo",
    "domain": "uniqlo.com",
    "logo": "https://www.google.com/s2/favicons?domain=uniqlo.com&sz=128",
    "description": "Japanese casual wear",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T10:45:32.844000"
  },
  {
    "id": "cbabb3f7-c867-46d0-b467-ba2e9a6f7fa5",
    "name": "American Eagle",
    "domain": "ae.com",
    "logo": "https://www.google.com/s2/favicons?domain=ae.com&sz=128",
    "description": "Jeans, clothing and accessories",
    "featured": true,
    "total_coupons": 6,
    "created_at": "2025-12-11T10:45:32.846000"
  },
  {
    "id": "8a7223c2-0337-4a7f-bd7e-6a27634fb8d1",
    "name": "Hollister",
    "domain": "hollisterco.com",
    "logo": "https://www.google.com/s2/favicons?domain=hollisterco.com&sz=128",
    "description": "California-inspired clothing",
    "featured": false,
    "total_coupons": 7,
    "created_at": "2025-12-11T10:45:32.848000"
  },
  {
    "id": "d9e6eaa0-7790-440f-9318-814243eaa8f8",
    "name": "Abercrombie & Fitch",
    "domain": "abercrombie.com",
    "logo": "https://www.google.com/s2/favicons?domain=abercrombie.com&sz=128",
    "description": "Classic American style",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T10:45:32.850000"
  },
  {
    "id": "f9bdd9ae-21e2-4237-a3ea-dd4da6ef5adc",
    "name": "Urban Outfitters",
    "domain": "urbanoutfitters.com",
    "logo": "https://www.google.com/s2/favicons?domain=urbanoutfitters.com&sz=128",
    "description": "Trendy clothing and lifestyle",
    "featured": false,
    "total_coupons": 6,
    "created_at": "2025-12-11T10:45:32.851000"
  },
  {
    "id": "fc82f624-2088-4bac-8c77-b7de927e6664",
    "name": "Anthropologie",
    "domain": "anthropologie.com",
    "logo": "https://www.google.com/s2/favicons?domain=anthropologie.com&sz=128",
    "description": "Unique womens fashion",
    "featured": false,
    "total_coupons": 7,
    "created_at": "2025-12-11T10:45:32.853000"
  },
  {
    "id": "056996f3-dafb-483d-92c2-33bfc5b868da",
    "name": "Free People",
    "domain": "freepeople.com",
    "logo": "https://www.google.com/s2/favicons?domain=freepeople.com&sz=128",
    "description": "Boho clothing and accessories",
    "featured": false,
    "total_coupons": 6,
    "created_at": "2025-12-11T10:45:32.855000"
  },
  {
    "id": "232f03dc-d1cc-40f4-900e-58cc25e7820e",
    "name": "Lululemon",
    "domain": "lululemon.com",
    "logo": "https://www.google.com/s2/favicons?domain=lululemon.com&sz=128",
    "description": "Athletic and yoga apparel",
    "featured": true,
    "total_coupons": 6,
    "created_at": "2025-12-11T10:45:32.857000"
  },
  {
    "id": "f00129a3-3ac8-4650-9c46-0c8d19223b10",
    "name": "J.Crew",
    "domain": "jcrew.com",
    "logo": "https://www.google.com/s2/favicons?domain=jcrew.com&sz=128",
    "description": "Classic American style",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T10:45:32.859000"
  },
  {
    "id": "ff318e97-379b-4585-a5f6-70eb56385c57",
    "name": "Banana Republic",
    "domain": "bananarepublic.gap.com",
    "logo": "https://www.google.com/s2/favicons?domain=bananarepublic.gap.com&sz=128",
    "description": "Modern classic clothing",
    "featured": false,
    "total_coupons": 6,
    "created_at": "2025-12-11T10:45:32.861000"
  },
  {
    "id": "e812e2e1-101f-4050-8e5e-b60c93316f71",
    "name": "Shein",
    "domain": "shein.com",
    "logo": "https://www.google.com/s2/favicons?domain=shein.com&sz=128",
    "description": "Affordable trendy fashion",
    "featured": true,
    "total_coupons": 7,
    "created_at": "2025-12-11T11:10:13.560000"
  },
  {
    "id": "3fced067-fc9f-4a77-ae10-ba4171907f70",
    "name": "Boohoo",
    "domain": "boohoo.com",
    "logo": "https://www.google.com/s2/favicons?domain=boohoo.com&sz=128",
    "description": "Fast fashion at great prices",
    "featured": false,
    "total_coupons": 8,
    "created_at": "2025-12-11T11:10:13.565000"
  },
  {
    "id": "03709aa8-a678-44f1-aaa7-f220241ee1e6",
    "name": "ASOS",
    "domain": "asos.com",
    "logo": "https://www.google.com/s2/favicons?domain=asos.com&sz=128",
    "description": "Global fashion destination",
    "featured": true,
    "total_coupons": 7,
    "created_at": "2025-12-11T11:10:13.568000"
  },
  {
    "id": "3af942df-d7d7-4b52-b3f5-fa43fc22d25f",
    "name": "Nordstrom",
    "domain": "nordstrom.com",
    "logo": "https://www.google.com/s2/favicons?domain=nordstrom.com&sz=128",
    "description": "Upscale fashion retailer",
    "featured": true,
    "total_coupons": 6,
    "created_at": "2025-12-11T11:10:13.572000"
  },
  {
    "id": "4cfc70d7-ee78-4ab7-b745-335667bcbea8",
    "name": "JCPenney",
    "domain": "jcpenney.com",
    "logo": "https://www.google.com/s2/favicons?domain=jcpenney.com&sz=128",
    "description": "Department store classics",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T11:10:13.574000"
  },
  {
    "id": "d92e9d5a-e25f-466d-ba3e-4647045bf2c7",
    "name": "Express",
    "domain": "express.com",
    "logo": "https://www.google.com/s2/favicons?domain=express.com&sz=128",
    "description": "Modern fashion essentials",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T11:10:13.577000"
  },
  {
    "id": "edd95cc1-3989-46e2-b860-1a91990451ba",
    "name": "PacSun",
    "domain": "pacsun.com",
    "logo": "https://www.google.com/s2/favicons?domain=pacsun.com&sz=128",
    "description": "California lifestyle clothing",
    "featured": false,
    "total_coupons": 7,
    "created_at": "2025-12-11T11:10:13.579000"
  },
  {
    "id": "2601effc-dd23-41ef-b9bb-3757fd579eec",
    "name": "Topshop",
    "domain": "topshop.com",
    "logo": "https://www.google.com/s2/favicons?domain=topshop.com&sz=128",
    "description": "British fashion brand",
    "featured": false,
    "total_coupons": 6,
    "created_at": "2025-12-11T11:10:13.583000"
  },
  {
    "id": "a53bcc67-349a-4a42-a777-bff12a934a45",
    "name": "Zales",
    "domain": "zales.com",
    "logo": "https://www.google.com/s2/favicons?domain=zales.com&sz=128",
    "description": "Jewelry and accessories",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T11:10:13.586000"
  },
  {
    "id": "279c9cd2-d0d0-46fa-b007-16695d9fd717",
    "name": "Victoria's Secret",
    "domain": "victoriassecret.com",
    "logo": "https://www.google.com/s2/favicons?domain=victoriassecret.com&sz=128",
    "description": "Lingerie and beauty",
    "featured": true,
    "total_coupons": 7,
    "created_at": "2025-12-11T11:10:13.588000"
  },
  {
    "id": "c1b6af5e-6e28-483e-b626-5e2433305578",
    "name": "Foot Locker",
    "domain": "footlocker.com",
    "logo": "https://www.google.com/s2/favicons?domain=footlocker.com&sz=128",
    "description": "Athletic shoes and apparel",
    "featured": false,
    "total_coupons": 7,
    "created_at": "2025-12-11T11:10:13.591000"
  },
  {
    "id": "31a683d9-3763-45a4-885a-1d29253f8ad0",
    "name": "Finish Line",
    "domain": "finishline.com",
    "logo": "https://www.google.com/s2/favicons?domain=finishline.com&sz=128",
    "description": "Premium athletic footwear",
    "featured": false,
    "total_coupons": 8,
    "created_at": "2025-12-11T11:10:13.594000"
  },
  {
    "id": "d6a34cd5-e815-446f-af73-35e1343a2172",
    "name": "Vans",
    "domain": "vans.com",
    "logo": "https://www.google.com/s2/favicons?domain=vans.com&sz=128",
    "description": "Skateboarding shoes and apparel",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T11:10:13.601000"
  },
  {
    "id": "f60cc4e1-4dfe-463b-b043-586e06edf19a",
    "name": "Reebok",
    "domain": "reebok.com",
    "logo": "https://www.google.com/s2/favicons?domain=reebok.com&sz=128",
    "description": "Athletic footwear and clothing",
    "featured": false,
    "total_coupons": 5,
    "created_at": "2025-12-11T11:10:13.604000"
  },
  {
    "id": "6e3109c1-ef9a-4d38-82ee-862267c8d983",
    "name": "Puma",
    "domain": "puma.com",
    "logo": "https://www.google.com/s2/favicons?domain=puma.com&sz=128",
    "description": "Sports lifestyle brand",
    "featured": true,
    "total_coupons": 7,
    "created_at": "2025-12-11T11:10:13.606000"
  },
  {
    "id": "cfeda609-045f-489c-8242-b7064fcd449c",
    "name": "New Balance",
    "domain": "newbalance.com",
    "logo": "https://www.google.com/s2/favicons?domain=newbalance.com&sz=128",
    "description": "Athletic footwear and apparel",
    "featured": false,
    "total_coupons": 6,
    "created_at": "2025-12-11T11:10:13.609000"
  },
  {
    "id": "4d87c189-d440-4f97-9618-92b8af65ff41",
    "name": "Calvin Klein",
    "domain": "calvinklein.com",
    "logo": "https://www.google.com/s2/favicons?domain=calvinklein.com&sz=128",
    "description": "Designer fashion and underwear",
    "featured": true,
    "total_coupons": 6,
    "created_at": "2025-12-11T11:10:13.612000"
  },
  {
    "id": "4e7ea571-999d-4d10-989f-207c2dd8e6e6",
    "name": "Tommy Hilfiger",
    "domain": "tommy.com",
    "logo": "https://www.google.com/s2/favicons?domain=tommy.com&sz=128",
    "description": "Classic American cool style",
    "featured": false,
    "total_coupons": 6,
    "created_at": "2025-12-11T11:10:13.614000"
  },
  {
    "id": "bd60d6cd-66e3-498d-a3ba-1bf7c45a2646",
    "name": "Ralph Lauren",
    "domain": "ralphlauren.com",
    "logo": "https://www.google.com/s2/favicons?domain=ralphlauren.com&sz=128",
    "description": "Iconic American designer brand",
    "featured": true,
    "total_coupons": 6,
    "created_at": "2025-12-11T11:10:13.617000"
  },
  {
    "id": "6a244039-b711-416a-8f12-318b575f84df",
    "name": "Guess",
    "domain": "guess.com",
    "logo": "https://www.google.com/s2/favicons?domain=guess.com&sz=128",
    "description": "Fashion-forward clothing",
    "featured": false,
    "total_coupons": 8,
    "created_at": "2025-12-11T11:10:13.620000"
  },
  {
    "id": "6d7c3a37-df56-4489-8ff5-94e7382e4d09",
    "name": "Mey & Edlich",
    "domain": "www.mey-edlich.de",
    "logo": "https://www.mey-edlich.de/on/demandware.static/Sites-meyedlich-Site/-/default/dw3fbc4b55/images/me-logo.svg",
    "description": "German fashion retailer offering high-quality men's clothing, suits, shirts, and accessories with classic European style.",
    "featured": true,
    "total_coupons": 5,
    "created_at": "2026-01-11T11:52:17.621377Z"
  }
];

export const COUPONS_DATA = [
  {
    "id": "92201a41-cc8e-4d80-ae75-34e30423cc9f",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Nike. Shop now and save big!",
    "code": "EXTRA70",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "62711996-ee12-430b-9c67-44267ca247bc",
    "store_name": "Nike",
    "store_domain": "nike.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$45.00",
    "featured": false,
    "expiry_date": "2026-02-15",
    "logo": "https://www.google.com/s2/favicons?domain=nike.com&sz=128",
    "created_at": "2025-12-11T10:17:04.883000"
  },
  {
    "id": "59dee29e-d26c-4717-90f5-5fe32f5e306a",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Nike. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "62711996-ee12-430b-9c67-44267ca247bc",
    "store_name": "Nike",
    "store_domain": "nike.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-01",
    "logo": "https://www.google.com/s2/favicons?domain=nike.com&sz=128",
    "created_at": "2025-12-11T10:17:04.894000"
  },
  {
    "id": "f99000b6-f353-4a1c-aab5-2744c8c8a2ed",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Nike. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "62711996-ee12-430b-9c67-44267ca247bc",
    "store_name": "Nike",
    "store_domain": "nike.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-18",
    "logo": "https://www.google.com/s2/favicons?domain=nike.com&sz=128",
    "created_at": "2025-12-11T10:17:04.894000"
  },
  {
    "id": "d76a4d44-cbcb-47dc-8819-ff8b6879767b",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Nike. Shop now and save big!",
    "code": "GETP83",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "62711996-ee12-430b-9c67-44267ca247bc",
    "store_name": "Nike",
    "store_domain": "nike.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$42.00",
    "featured": false,
    "expiry_date": "2026-02-23",
    "logo": "https://www.google.com/s2/favicons?domain=nike.com&sz=128",
    "created_at": "2025-12-11T10:17:04.894000"
  },
  {
    "id": "7a76c53d-a593-4497-a53b-66eee25d1c3e",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Nike. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "62711996-ee12-430b-9c67-44267ca247bc",
    "store_name": "Nike",
    "store_domain": "nike.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2026-01-24",
    "logo": "https://www.google.com/s2/favicons?domain=nike.com&sz=128",
    "created_at": "2025-12-11T10:17:04.895000"
  },
  {
    "id": "5f57d45d-31c1-4608-8a20-a417e945ec04",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Nike. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "62711996-ee12-430b-9c67-44267ca247bc",
    "store_name": "Nike",
    "store_domain": "nike.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-02",
    "logo": "https://www.google.com/s2/favicons?domain=nike.com&sz=128",
    "created_at": "2025-12-11T10:17:04.895000"
  },
  {
    "id": "6e3e9c31-9790-4c82-ba18-cb32dfd2a01f",
    "title": "Buy 2 Get 1 Free on Select Items",
    "description": "Get 50% off on your purchase at Nike. Shop now and save big!",
    "code": "SHOPO88",
    "discount": "50% OFF",
    "type": "code",
    "store_id": "62711996-ee12-430b-9c67-44267ca247bc",
    "store_name": "Nike",
    "store_domain": "nike.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$80.00",
    "featured": false,
    "expiry_date": "2026-02-19",
    "logo": "https://www.google.com/s2/favicons?domain=nike.com&sz=128",
    "created_at": "2025-12-11T10:17:04.895000"
  },
  {
    "id": "ece347f0-8e9a-455b-82e7-b21ef30d1daa",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Amazon. Shop now and save big!",
    "code": "AMA34",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "14f03419-f0ba-4fae-970f-e151f0423419",
    "store_name": "Amazon",
    "store_domain": "amazon.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$53.00",
    "featured": false,
    "expiry_date": "2026-01-11",
    "logo": "https://www.google.com/s2/favicons?domain=amazon.com&sz=128",
    "created_at": "2025-12-11T10:17:04.895000"
  },
  {
    "id": "0002a24e-d05a-4eb1-9ebb-1b5e9a1d8937",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Amazon. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "14f03419-f0ba-4fae-970f-e151f0423419",
    "store_name": "Amazon",
    "store_domain": "amazon.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-26",
    "logo": "https://www.google.com/s2/favicons?domain=amazon.com&sz=128",
    "created_at": "2025-12-11T10:17:04.896000"
  },
  {
    "id": "e99f4c14-e120-4f6a-b368-e6f6c5bc643e",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Amazon. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "14f03419-f0ba-4fae-970f-e151f0423419",
    "store_name": "Amazon",
    "store_domain": "amazon.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-24",
    "logo": "https://www.google.com/s2/favicons?domain=amazon.com&sz=128",
    "created_at": "2025-12-11T10:17:04.896000"
  },
  {
    "id": "abe34b12-f771-4e62-a2ef-ec3acfa61278",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Amazon. Shop now and save big!",
    "code": "AMA12",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "14f03419-f0ba-4fae-970f-e151f0423419",
    "store_name": "Amazon",
    "store_domain": "amazon.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$20.00",
    "featured": false,
    "expiry_date": "2026-01-13",
    "logo": "https://www.google.com/s2/favicons?domain=amazon.com&sz=128",
    "created_at": "2025-12-11T10:17:04.896000"
  },
  {
    "id": "1e1a65cf-7476-4a0f-ad90-34af2c0d07dc",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Amazon. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "14f03419-f0ba-4fae-970f-e151f0423419",
    "store_name": "Amazon",
    "store_domain": "amazon.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-03",
    "logo": "https://www.google.com/s2/favicons?domain=amazon.com&sz=128",
    "created_at": "2025-12-11T10:17:04.896000"
  },
  {
    "id": "936cee23-93e3-4399-9523-5dc3bb3553a3",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Adidas. Shop now and save big!",
    "code": "WELCOMEF29",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "033c7eec-28fc-48a2-bd09-667f201df9fb",
    "store_name": "Adidas",
    "store_domain": "adidas.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$84.00",
    "featured": false,
    "expiry_date": "2025-12-28",
    "logo": "https://www.google.com/s2/favicons?domain=adidas.com&sz=128",
    "created_at": "2025-12-11T10:17:04.897000"
  },
  {
    "id": "baba528b-58e0-4dfc-9090-3bd99f7809cf",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Adidas. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "033c7eec-28fc-48a2-bd09-667f201df9fb",
    "store_name": "Adidas",
    "store_domain": "adidas.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-21",
    "logo": "https://www.google.com/s2/favicons?domain=adidas.com&sz=128",
    "created_at": "2025-12-11T10:17:04.897000"
  },
  {
    "id": "309df594-6ea2-44a5-9c21-aa2af8a41e82",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Adidas. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "033c7eec-28fc-48a2-bd09-667f201df9fb",
    "store_name": "Adidas",
    "store_domain": "adidas.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-20",
    "logo": "https://www.google.com/s2/favicons?domain=adidas.com&sz=128",
    "created_at": "2025-12-11T10:17:04.897000"
  },
  {
    "id": "590c5190-3fc1-4bc9-9c8b-142aa781ff55",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Adidas. Shop now and save big!",
    "code": "DEAL75",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "033c7eec-28fc-48a2-bd09-667f201df9fb",
    "store_name": "Adidas",
    "store_domain": "adidas.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$17.00",
    "featured": false,
    "expiry_date": "2026-01-10",
    "logo": "https://www.google.com/s2/favicons?domain=adidas.com&sz=128",
    "created_at": "2025-12-11T10:17:04.897000"
  },
  {
    "id": "e89fd0f4-2c06-4524-bade-eda5bdc94aa0",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Adidas. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "033c7eec-28fc-48a2-bd09-667f201df9fb",
    "store_name": "Adidas",
    "store_domain": "adidas.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-12",
    "logo": "https://www.google.com/s2/favicons?domain=adidas.com&sz=128",
    "created_at": "2025-12-11T10:17:04.897000"
  },
  {
    "id": "9a573d6a-2519-45bd-ba5d-5989ba30a31c",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Macy's. Shop now and save big!",
    "code": "EXTRAD79",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "bc937020-1603-4447-9f78-ae56f9ad75cb",
    "store_name": "Macy's",
    "store_domain": "macys.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$23.00",
    "featured": false,
    "expiry_date": "2026-02-02",
    "logo": "https://www.google.com/s2/favicons?domain=macys.com&sz=128",
    "created_at": "2025-12-11T10:17:04.898000"
  },
  {
    "id": "5bfc9ebe-ebbe-4545-aad3-4be74b53ebf4",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Macy's. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "bc937020-1603-4447-9f78-ae56f9ad75cb",
    "store_name": "Macy's",
    "store_domain": "macys.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-08",
    "logo": "https://www.google.com/s2/favicons?domain=macys.com&sz=128",
    "created_at": "2025-12-11T10:17:04.899000"
  },
  {
    "id": "82449b7f-55b0-45c6-82dd-d3038945f0c8",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Macy's. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "bc937020-1603-4447-9f78-ae56f9ad75cb",
    "store_name": "Macy's",
    "store_domain": "macys.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-03",
    "logo": "https://www.google.com/s2/favicons?domain=macys.com&sz=128",
    "created_at": "2025-12-11T10:17:04.899000"
  },
  {
    "id": "158eabf2-9525-4ec4-bea9-256ee1ddd1ad",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Macy's. Shop now and save big!",
    "code": "SHOPR27",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "bc937020-1603-4447-9f78-ae56f9ad75cb",
    "store_name": "Macy's",
    "store_domain": "macys.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$68.00",
    "featured": false,
    "expiry_date": "2026-03-06",
    "logo": "https://www.google.com/s2/favicons?domain=macys.com&sz=128",
    "created_at": "2025-12-11T10:17:04.899000"
  },
  {
    "id": "1c0095c2-e8fe-4798-891e-18eaacdc3a4b",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Macy's. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "bc937020-1603-4447-9f78-ae56f9ad75cb",
    "store_name": "Macy's",
    "store_domain": "macys.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-07",
    "logo": "https://www.google.com/s2/favicons?domain=macys.com&sz=128",
    "created_at": "2025-12-11T10:17:04.899000"
  },
  {
    "id": "e96055a6-2012-4f08-8103-8ccb0b034f0c",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Macy's. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "bc937020-1603-4447-9f78-ae56f9ad75cb",
    "store_name": "Macy's",
    "store_domain": "macys.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-24",
    "logo": "https://www.google.com/s2/favicons?domain=macys.com&sz=128",
    "created_at": "2025-12-11T10:17:04.900000"
  },
  {
    "id": "177dd723-9df4-4886-bb87-c43a87ca3962",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Target. Shop now and save big!",
    "code": "SHOPY98",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "eb7aa46d-aae7-4071-86bf-af284995647e",
    "store_name": "Target",
    "store_domain": "target.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$61.00",
    "featured": true,
    "expiry_date": "2026-01-26",
    "logo": "https://www.google.com/s2/favicons?domain=target.com&sz=128",
    "created_at": "2025-12-11T10:17:04.900000"
  },
  {
    "id": "78ec9517-a152-4a67-b150-69c03a5dcc20",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Target. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "eb7aa46d-aae7-4071-86bf-af284995647e",
    "store_name": "Target",
    "store_domain": "target.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-18",
    "logo": "https://www.google.com/s2/favicons?domain=target.com&sz=128",
    "created_at": "2025-12-11T10:17:04.900000"
  },
  {
    "id": "a33c4860-bc76-46f2-9276-04458032efc1",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Target. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "eb7aa46d-aae7-4071-86bf-af284995647e",
    "store_name": "Target",
    "store_domain": "target.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2025-12-28",
    "logo": "https://www.google.com/s2/favicons?domain=target.com&sz=128",
    "created_at": "2025-12-11T10:17:04.901000"
  },
  {
    "id": "9a491c6e-dc81-476d-a7f1-6d773455fe91",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Target. Shop now and save big!",
    "code": "QXUZ34",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "eb7aa46d-aae7-4071-86bf-af284995647e",
    "store_name": "Target",
    "store_domain": "target.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$62.00",
    "featured": false,
    "expiry_date": "2026-01-13",
    "logo": "https://www.google.com/s2/favicons?domain=target.com&sz=128",
    "created_at": "2025-12-11T10:17:04.901000"
  },
  {
    "id": "1455f3e6-518e-4be4-add8-db34ffe2d4ac",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Target. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "eb7aa46d-aae7-4071-86bf-af284995647e",
    "store_name": "Target",
    "store_domain": "target.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-20",
    "logo": "https://www.google.com/s2/favicons?domain=target.com&sz=128",
    "created_at": "2025-12-11T10:17:04.901000"
  },
  {
    "id": "43f6110b-c097-48db-8763-940fb048117b",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Target. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "eb7aa46d-aae7-4071-86bf-af284995647e",
    "store_name": "Target",
    "store_domain": "target.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-04",
    "logo": "https://www.google.com/s2/favicons?domain=target.com&sz=128",
    "created_at": "2025-12-11T10:17:04.901000"
  },
  {
    "id": "b54f1b03-7437-4a48-a775-85435456ba5a",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Walmart. Shop now and save big!",
    "code": "WAL26",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "51b3aa89-74b9-4a29-b842-7a215e15cb79",
    "store_name": "Walmart",
    "store_domain": "walmart.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$23.00",
    "featured": false,
    "expiry_date": "2026-02-20",
    "logo": "https://www.google.com/s2/favicons?domain=walmart.com&sz=128",
    "created_at": "2025-12-11T10:17:04.902000"
  },
  {
    "id": "ae300e1a-bcee-4071-97cb-1371445f4b4e",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Walmart. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "51b3aa89-74b9-4a29-b842-7a215e15cb79",
    "store_name": "Walmart",
    "store_domain": "walmart.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-11",
    "logo": "https://www.google.com/s2/favicons?domain=walmart.com&sz=128",
    "created_at": "2025-12-11T10:17:04.902000"
  },
  {
    "id": "ac9e38fc-e87d-4563-a248-7654fc9cf74b",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Walmart. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "51b3aa89-74b9-4a29-b842-7a215e15cb79",
    "store_name": "Walmart",
    "store_domain": "walmart.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-05",
    "logo": "https://www.google.com/s2/favicons?domain=walmart.com&sz=128",
    "created_at": "2025-12-11T10:17:04.902000"
  },
  {
    "id": "cb3a3db3-24e4-4b21-872f-9e8fcba3640c",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Walmart. Shop now and save big!",
    "code": "WELCOMEK13",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "51b3aa89-74b9-4a29-b842-7a215e15cb79",
    "store_name": "Walmart",
    "store_domain": "walmart.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$28.00",
    "featured": true,
    "expiry_date": "2026-01-03",
    "logo": "https://www.google.com/s2/favicons?domain=walmart.com&sz=128",
    "created_at": "2025-12-11T10:17:04.902000"
  },
  {
    "id": "2a4f2482-54c3-4cfe-b7e6-a6bc08f64b59",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Walmart. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "51b3aa89-74b9-4a29-b842-7a215e15cb79",
    "store_name": "Walmart",
    "store_domain": "walmart.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2025-12-30",
    "logo": "https://www.google.com/s2/favicons?domain=walmart.com&sz=128",
    "created_at": "2025-12-11T10:17:04.902000"
  },
  {
    "id": "cd0b597c-9d64-418f-875c-5dc00714b290",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Walmart. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "51b3aa89-74b9-4a29-b842-7a215e15cb79",
    "store_name": "Walmart",
    "store_domain": "walmart.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-30",
    "logo": "https://www.google.com/s2/favicons?domain=walmart.com&sz=128",
    "created_at": "2025-12-11T10:17:04.902000"
  },
  {
    "id": "5e319ad8-aff6-49ac-ae6b-4a49e09a3a66",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Nordstrom Rack. Shop now and save big!",
    "code": "WELCOMER44",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "275a202a-54a2-43c1-8fd6-192642273a55",
    "store_name": "Nordstrom Rack",
    "store_domain": "nordstromrack.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$87.00",
    "featured": true,
    "expiry_date": "2026-01-16",
    "logo": "https://www.google.com/s2/favicons?domain=nordstromrack.com&sz=128",
    "created_at": "2025-12-11T10:17:04.903000"
  },
  {
    "id": "55d68259-5c81-4072-9fea-516cd0f4ff4f",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Nordstrom Rack. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "275a202a-54a2-43c1-8fd6-192642273a55",
    "store_name": "Nordstrom Rack",
    "store_domain": "nordstromrack.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-06",
    "logo": "https://www.google.com/s2/favicons?domain=nordstromrack.com&sz=128",
    "created_at": "2025-12-11T10:17:04.903000"
  },
  {
    "id": "fd9caa3c-f052-46ad-ad40-009a47de4cec",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Nordstrom Rack. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "275a202a-54a2-43c1-8fd6-192642273a55",
    "store_name": "Nordstrom Rack",
    "store_domain": "nordstromrack.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-29",
    "logo": "https://www.google.com/s2/favicons?domain=nordstromrack.com&sz=128",
    "created_at": "2025-12-11T10:17:04.903000"
  },
  {
    "id": "e817d06a-b08d-44d0-bfc2-ea17b4225271",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Nordstrom Rack. Shop now and save big!",
    "code": "GJJE87",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "275a202a-54a2-43c1-8fd6-192642273a55",
    "store_name": "Nordstrom Rack",
    "store_domain": "nordstromrack.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$31.00",
    "featured": false,
    "expiry_date": "2026-02-14",
    "logo": "https://www.google.com/s2/favicons?domain=nordstromrack.com&sz=128",
    "created_at": "2025-12-11T10:17:04.903000"
  },
  {
    "id": "5388e7ee-5570-48dc-a72c-81586d06f052",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Nordstrom Rack. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "275a202a-54a2-43c1-8fd6-192642273a55",
    "store_name": "Nordstrom Rack",
    "store_domain": "nordstromrack.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-05",
    "logo": "https://www.google.com/s2/favicons?domain=nordstromrack.com&sz=128",
    "created_at": "2025-12-11T10:17:04.904000"
  },
  {
    "id": "f1b56316-dcc9-43e3-b7c1-8ec06f2ca410",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Nordstrom Rack. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "275a202a-54a2-43c1-8fd6-192642273a55",
    "store_name": "Nordstrom Rack",
    "store_domain": "nordstromrack.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-25",
    "logo": "https://www.google.com/s2/favicons?domain=nordstromrack.com&sz=128",
    "created_at": "2025-12-11T10:17:04.904000"
  },
  {
    "id": "14c2054e-2bd5-4083-b217-8a806666398e",
    "title": "Buy 2 Get 1 Free on Select Items",
    "description": "Get 50% off on your purchase at Nordstrom Rack. Shop now and save big!",
    "code": "QWIQ56",
    "discount": "50% OFF",
    "type": "code",
    "store_id": "275a202a-54a2-43c1-8fd6-192642273a55",
    "store_name": "Nordstrom Rack",
    "store_domain": "nordstromrack.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$20.00",
    "featured": false,
    "expiry_date": "2026-03-09",
    "logo": "https://www.google.com/s2/favicons?domain=nordstromrack.com&sz=128",
    "created_at": "2025-12-11T10:17:04.904000"
  },
  {
    "id": "88633736-9d3a-407f-a693-e05f429cee17",
    "title": "Clearance Sale: Up to $75 off Off",
    "description": "Get $75 off on your purchase at Nordstrom Rack. Shop now and save big!",
    "code": null,
    "discount": "$75 OFF",
    "type": "deal",
    "store_id": "275a202a-54a2-43c1-8fd6-192642273a55",
    "store_name": "Nordstrom Rack",
    "store_domain": "nordstromrack.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-26",
    "logo": "https://www.google.com/s2/favicons?domain=nordstromrack.com&sz=128",
    "created_at": "2025-12-11T10:17:04.904000"
  },
  {
    "id": "d5ebbae8-57f2-475f-b73f-e3fee429a0c9",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Kohl's. Shop now and save big!",
    "code": "DEAL23",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "2c90d993-26e4-4f71-bc19-b3d487570dc2",
    "store_name": "Kohl's",
    "store_domain": "kohls.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$88.00",
    "featured": true,
    "expiry_date": "2026-02-05",
    "logo": "https://www.google.com/s2/favicons?domain=kohls.com&sz=128",
    "created_at": "2025-12-11T10:17:04.905000"
  },
  {
    "id": "cee95f01-1112-41cd-b6e2-4772ebb30f58",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Kohl's. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "2c90d993-26e4-4f71-bc19-b3d487570dc2",
    "store_name": "Kohl's",
    "store_domain": "kohls.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-12",
    "logo": "https://www.google.com/s2/favicons?domain=kohls.com&sz=128",
    "created_at": "2025-12-11T10:17:04.905000"
  },
  {
    "id": "1545fff9-5923-4801-b2c7-6850149aa159",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Kohl's. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "2c90d993-26e4-4f71-bc19-b3d487570dc2",
    "store_name": "Kohl's",
    "store_domain": "kohls.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-13",
    "logo": "https://www.google.com/s2/favicons?domain=kohls.com&sz=128",
    "created_at": "2025-12-11T10:17:04.905000"
  },
  {
    "id": "60ed7ace-709c-4f9a-9f4e-d669b2746915",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Kohl's. Shop now and save big!",
    "code": "EXTRA18",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "2c90d993-26e4-4f71-bc19-b3d487570dc2",
    "store_name": "Kohl's",
    "store_domain": "kohls.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$53.00",
    "featured": false,
    "expiry_date": "2026-01-03",
    "logo": "https://www.google.com/s2/favicons?domain=kohls.com&sz=128",
    "created_at": "2025-12-11T10:17:04.905000"
  },
  {
    "id": "5c9179c1-0df5-4dd7-9f27-c3280e586c5b",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Kohl's. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "2c90d993-26e4-4f71-bc19-b3d487570dc2",
    "store_name": "Kohl's",
    "store_domain": "kohls.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-10",
    "logo": "https://www.google.com/s2/favicons?domain=kohls.com&sz=128",
    "created_at": "2025-12-11T10:17:04.905000"
  },
  {
    "id": "a924cb3d-8553-473e-bac9-a1a8955b35d3",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Kohl's. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "2c90d993-26e4-4f71-bc19-b3d487570dc2",
    "store_name": "Kohl's",
    "store_domain": "kohls.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2025-12-26",
    "logo": "https://www.google.com/s2/favicons?domain=kohls.com&sz=128",
    "created_at": "2025-12-11T10:17:04.905000"
  },
  {
    "id": "335edace-8cbf-4eaa-a214-aef82a47977f",
    "title": "Buy 2 Get 1 Free on Select Items",
    "description": "Get 50% off on your purchase at Kohl's. Shop now and save big!",
    "code": "EXTRA74",
    "discount": "50% OFF",
    "type": "code",
    "store_id": "2c90d993-26e4-4f71-bc19-b3d487570dc2",
    "store_name": "Kohl's",
    "store_domain": "kohls.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$8.00",
    "featured": false,
    "expiry_date": "2026-01-27",
    "logo": "https://www.google.com/s2/favicons?domain=kohls.com&sz=128",
    "created_at": "2025-12-11T10:17:04.906000"
  },
  {
    "id": "79de4a0c-9961-4249-83a8-7d606a527b08",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Best Buy. Shop now and save big!",
    "code": "SHOPS72",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "e75a01d1-6989-462c-a861-53d404b70656",
    "store_name": "Best Buy",
    "store_domain": "bestbuy.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$76.00",
    "featured": false,
    "expiry_date": "2026-03-11",
    "logo": "https://www.google.com/s2/favicons?domain=bestbuy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.906000"
  },
  {
    "id": "5d35a1ca-379c-433e-a347-cb0a8b1b71c8",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Best Buy. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "e75a01d1-6989-462c-a861-53d404b70656",
    "store_name": "Best Buy",
    "store_domain": "bestbuy.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2025-12-27",
    "logo": "https://www.google.com/s2/favicons?domain=bestbuy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.906000"
  },
  {
    "id": "f56a9536-34ae-4c34-a865-d5548cd0ddf6",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Best Buy. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "e75a01d1-6989-462c-a861-53d404b70656",
    "store_name": "Best Buy",
    "store_domain": "bestbuy.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-26",
    "logo": "https://www.google.com/s2/favicons?domain=bestbuy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.906000"
  },
  {
    "id": "617352ae-b97c-4fef-baec-03eae60a9a30",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Best Buy. Shop now and save big!",
    "code": "SAVEQ79",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "e75a01d1-6989-462c-a861-53d404b70656",
    "store_name": "Best Buy",
    "store_domain": "bestbuy.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$84.00",
    "featured": true,
    "expiry_date": "2026-02-15",
    "logo": "https://www.google.com/s2/favicons?domain=bestbuy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.907000"
  },
  {
    "id": "9afb2208-f150-4ce2-8747-3c67c44e46b7",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Best Buy. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "e75a01d1-6989-462c-a861-53d404b70656",
    "store_name": "Best Buy",
    "store_domain": "bestbuy.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-19",
    "logo": "https://www.google.com/s2/favicons?domain=bestbuy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.907000"
  },
  {
    "id": "534969ba-d4b4-48d3-a9fb-09a4078fa754",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Best Buy. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "e75a01d1-6989-462c-a861-53d404b70656",
    "store_name": "Best Buy",
    "store_domain": "bestbuy.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-17",
    "logo": "https://www.google.com/s2/favicons?domain=bestbuy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.907000"
  },
  {
    "id": "b826cb41-a6d4-49cd-9887-7d8879130f68",
    "title": "Buy 2 Get 1 Free on Select Items",
    "description": "Get 50% off on your purchase at Best Buy. Shop now and save big!",
    "code": "JNBV94",
    "discount": "50% OFF",
    "type": "code",
    "store_id": "e75a01d1-6989-462c-a861-53d404b70656",
    "store_name": "Best Buy",
    "store_domain": "bestbuy.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$52.00",
    "featured": false,
    "expiry_date": "2026-02-09",
    "logo": "https://www.google.com/s2/favicons?domain=bestbuy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.907000"
  },
  {
    "id": "731a3007-fc46-4d54-b755-89bcd783d50b",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Sephora. Shop now and save big!",
    "code": "GET82",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "aec86b07-805d-4070-9d54-00e2aaf105b9",
    "store_name": "Sephora",
    "store_domain": "sephora.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$29.00",
    "featured": false,
    "expiry_date": "2026-01-10",
    "logo": "https://www.google.com/s2/favicons?domain=sephora.com&sz=128",
    "created_at": "2025-12-11T10:17:04.908000"
  },
  {
    "id": "5af5b378-ed2a-4f3f-b411-f05ada39f38f",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Sephora. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "aec86b07-805d-4070-9d54-00e2aaf105b9",
    "store_name": "Sephora",
    "store_domain": "sephora.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-18",
    "logo": "https://www.google.com/s2/favicons?domain=sephora.com&sz=128",
    "created_at": "2025-12-11T10:17:04.908000"
  },
  {
    "id": "044f31d8-43fd-499d-93f6-275838f975dc",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Sephora. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "aec86b07-805d-4070-9d54-00e2aaf105b9",
    "store_name": "Sephora",
    "store_domain": "sephora.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-02",
    "logo": "https://www.google.com/s2/favicons?domain=sephora.com&sz=128",
    "created_at": "2025-12-11T10:17:04.908000"
  },
  {
    "id": "b7a55350-4655-4cae-b8e3-37195627bf19",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Sephora. Shop now and save big!",
    "code": "KMUH72",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "aec86b07-805d-4070-9d54-00e2aaf105b9",
    "store_name": "Sephora",
    "store_domain": "sephora.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$21.00",
    "featured": false,
    "expiry_date": "2026-02-22",
    "logo": "https://www.google.com/s2/favicons?domain=sephora.com&sz=128",
    "created_at": "2025-12-11T10:17:04.908000"
  },
  {
    "id": "1bbef690-4902-45ab-b638-30b1a1d1ce17",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Sephora. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "aec86b07-805d-4070-9d54-00e2aaf105b9",
    "store_name": "Sephora",
    "store_domain": "sephora.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-22",
    "logo": "https://www.google.com/s2/favicons?domain=sephora.com&sz=128",
    "created_at": "2025-12-11T10:17:04.908000"
  },
  {
    "id": "63b22363-ad72-45c0-b287-23f3397bfcd2",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Old Navy. Shop now and save big!",
    "code": "OLD71",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "228d61ef-2327-4d6a-a7fa-2b59a7dc7b0f",
    "store_name": "Old Navy",
    "store_domain": "oldnavy.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$72.00",
    "featured": false,
    "expiry_date": "2026-02-26",
    "logo": "https://www.google.com/s2/favicons?domain=oldnavy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.909000"
  },
  {
    "id": "2515aae3-8cda-463a-bb62-952f781ff92d",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Old Navy. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "228d61ef-2327-4d6a-a7fa-2b59a7dc7b0f",
    "store_name": "Old Navy",
    "store_domain": "oldnavy.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-26",
    "logo": "https://www.google.com/s2/favicons?domain=oldnavy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.909000"
  },
  {
    "id": "1be1f65c-9092-47dc-a779-88f94d426476",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Old Navy. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "228d61ef-2327-4d6a-a7fa-2b59a7dc7b0f",
    "store_name": "Old Navy",
    "store_domain": "oldnavy.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-08",
    "logo": "https://www.google.com/s2/favicons?domain=oldnavy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.909000"
  },
  {
    "id": "100e27a4-3f47-4ff7-a240-6a579631dea9",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Old Navy. Shop now and save big!",
    "code": "DEAL95",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "228d61ef-2327-4d6a-a7fa-2b59a7dc7b0f",
    "store_name": "Old Navy",
    "store_domain": "oldnavy.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$14.00",
    "featured": true,
    "expiry_date": "2025-12-27",
    "logo": "https://www.google.com/s2/favicons?domain=oldnavy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.909000"
  },
  {
    "id": "c6f1403b-8b0f-43cf-a546-df8f96414880",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Old Navy. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "228d61ef-2327-4d6a-a7fa-2b59a7dc7b0f",
    "store_name": "Old Navy",
    "store_domain": "oldnavy.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2025-12-29",
    "logo": "https://www.google.com/s2/favicons?domain=oldnavy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.909000"
  },
  {
    "id": "c867c3b0-b358-414f-96ec-4f0cd63f14b0",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Old Navy. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "228d61ef-2327-4d6a-a7fa-2b59a7dc7b0f",
    "store_name": "Old Navy",
    "store_domain": "oldnavy.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-02",
    "logo": "https://www.google.com/s2/favicons?domain=oldnavy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.910000"
  },
  {
    "id": "1e446849-106b-4ff6-ab41-c258c89f4608",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Under Armour. Shop now and save big!",
    "code": "XGQD99",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "0909f958-443c-4280-90ec-96503185f4d9",
    "store_name": "Under Armour",
    "store_domain": "underarmour.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$21.00",
    "featured": false,
    "expiry_date": "2026-01-07",
    "logo": "https://www.google.com/s2/favicons?domain=underarmour.com&sz=128",
    "created_at": "2025-12-11T10:17:04.910000"
  },
  {
    "id": "12d4ab2d-44dd-46ab-9050-29d1f7afe172",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Under Armour. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "0909f958-443c-4280-90ec-96503185f4d9",
    "store_name": "Under Armour",
    "store_domain": "underarmour.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-22",
    "logo": "https://www.google.com/s2/favicons?domain=underarmour.com&sz=128",
    "created_at": "2025-12-11T10:17:04.911000"
  },
  {
    "id": "7cf86e6b-0328-46d8-9338-34eb7aad9016",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Under Armour. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "0909f958-443c-4280-90ec-96503185f4d9",
    "store_name": "Under Armour",
    "store_domain": "underarmour.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-21",
    "logo": "https://www.google.com/s2/favicons?domain=underarmour.com&sz=128",
    "created_at": "2025-12-11T10:17:04.911000"
  },
  {
    "id": "d0551dea-3534-4d87-882b-671ea934d51e",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Under Armour. Shop now and save big!",
    "code": "DEAL36",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "0909f958-443c-4280-90ec-96503185f4d9",
    "store_name": "Under Armour",
    "store_domain": "underarmour.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$75.00",
    "featured": false,
    "expiry_date": "2026-02-17",
    "logo": "https://www.google.com/s2/favicons?domain=underarmour.com&sz=128",
    "created_at": "2025-12-11T10:17:04.911000"
  },
  {
    "id": "cb88052b-a510-421d-b4fb-9ce10c88ebe9",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Under Armour. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "0909f958-443c-4280-90ec-96503185f4d9",
    "store_name": "Under Armour",
    "store_domain": "underarmour.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-25",
    "logo": "https://www.google.com/s2/favicons?domain=underarmour.com&sz=128",
    "created_at": "2025-12-11T10:17:04.912000"
  },
  {
    "id": "a3fdd943-153b-4f25-8b81-8495dd98a93a",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Wayfair. Shop now and save big!",
    "code": "SHOP76",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "1db189ed-7203-463d-afcd-b4d70a45e40d",
    "store_name": "Wayfair",
    "store_domain": "wayfair.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$49.00",
    "featured": false,
    "expiry_date": "2026-01-18",
    "logo": "https://www.google.com/s2/favicons?domain=wayfair.com&sz=128",
    "created_at": "2025-12-11T10:17:04.912000"
  },
  {
    "id": "3bf74f4f-4bed-4461-a5ad-a264d07e3663",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Wayfair. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "1db189ed-7203-463d-afcd-b4d70a45e40d",
    "store_name": "Wayfair",
    "store_domain": "wayfair.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-04",
    "logo": "https://www.google.com/s2/favicons?domain=wayfair.com&sz=128",
    "created_at": "2025-12-11T10:17:04.912000"
  },
  {
    "id": "075a3843-85f7-41e7-89af-c2251d1ba27b",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Wayfair. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "1db189ed-7203-463d-afcd-b4d70a45e40d",
    "store_name": "Wayfair",
    "store_domain": "wayfair.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-29",
    "logo": "https://www.google.com/s2/favicons?domain=wayfair.com&sz=128",
    "created_at": "2025-12-11T10:17:04.912000"
  },
  {
    "id": "3099530d-d04a-4060-b7c1-15dbb22d2bb5",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Wayfair. Shop now and save big!",
    "code": "EXTRAH80",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "1db189ed-7203-463d-afcd-b4d70a45e40d",
    "store_name": "Wayfair",
    "store_domain": "wayfair.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$27.00",
    "featured": false,
    "expiry_date": "2026-01-30",
    "logo": "https://www.google.com/s2/favicons?domain=wayfair.com&sz=128",
    "created_at": "2025-12-11T10:17:04.913000"
  },
  {
    "id": "5882834f-be68-4c32-b583-a079f16b114c",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Wayfair. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "1db189ed-7203-463d-afcd-b4d70a45e40d",
    "store_name": "Wayfair",
    "store_domain": "wayfair.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-08",
    "logo": "https://www.google.com/s2/favicons?domain=wayfair.com&sz=128",
    "created_at": "2025-12-11T10:17:04.913000"
  },
  {
    "id": "1d6af710-c91a-4797-907e-b32440c43ac8",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Wayfair. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "1db189ed-7203-463d-afcd-b4d70a45e40d",
    "store_name": "Wayfair",
    "store_domain": "wayfair.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2026-01-24",
    "logo": "https://www.google.com/s2/favicons?domain=wayfair.com&sz=128",
    "created_at": "2025-12-11T10:17:04.913000"
  },
  {
    "id": "f7a40b82-8c1f-43a0-977a-f8ed39be2260",
    "title": "Buy 2 Get 1 Free on Select Items",
    "description": "Get 50% off on your purchase at Wayfair. Shop now and save big!",
    "code": "QIKT23",
    "discount": "50% OFF",
    "type": "code",
    "store_id": "1db189ed-7203-463d-afcd-b4d70a45e40d",
    "store_name": "Wayfair",
    "store_domain": "wayfair.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$65.00",
    "featured": false,
    "expiry_date": "2026-01-27",
    "logo": "https://www.google.com/s2/favicons?domain=wayfair.com&sz=128",
    "created_at": "2025-12-11T10:17:04.913000"
  },
  {
    "id": "f4a72e49-7ffa-487b-aa6a-51c7bb596e16",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Gap. Shop now and save big!",
    "code": "DEAL69",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "0ee3915c-cc47-48cc-817b-cc088f340294",
    "store_name": "Gap",
    "store_domain": "gap.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$60.00",
    "featured": false,
    "expiry_date": "2026-02-22",
    "logo": "https://www.google.com/s2/favicons?domain=gap.com&sz=128",
    "created_at": "2025-12-11T10:17:04.914000"
  },
  {
    "id": "cc4d17f0-732f-40e5-9376-9715c5a1cbc6",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Gap. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "0ee3915c-cc47-48cc-817b-cc088f340294",
    "store_name": "Gap",
    "store_domain": "gap.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2026-02-01",
    "logo": "https://www.google.com/s2/favicons?domain=gap.com&sz=128",
    "created_at": "2025-12-11T10:17:04.914000"
  },
  {
    "id": "69781496-03d9-4210-ace3-dd70ec0b00a7",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Gap. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "0ee3915c-cc47-48cc-817b-cc088f340294",
    "store_name": "Gap",
    "store_domain": "gap.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2025-12-30",
    "logo": "https://www.google.com/s2/favicons?domain=gap.com&sz=128",
    "created_at": "2025-12-11T10:17:04.914000"
  },
  {
    "id": "7ce899dd-7fae-40ea-8feb-9787d35fd892",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Gap. Shop now and save big!",
    "code": "GAP76",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "0ee3915c-cc47-48cc-817b-cc088f340294",
    "store_name": "Gap",
    "store_domain": "gap.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$8.00",
    "featured": false,
    "expiry_date": "2026-02-27",
    "logo": "https://www.google.com/s2/favicons?domain=gap.com&sz=128",
    "created_at": "2025-12-11T10:17:04.914000"
  },
  {
    "id": "9f0e454a-b6aa-4a80-8dad-ff4a196fb904",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Gap. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "0ee3915c-cc47-48cc-817b-cc088f340294",
    "store_name": "Gap",
    "store_domain": "gap.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2026-02-17",
    "logo": "https://www.google.com/s2/favicons?domain=gap.com&sz=128",
    "created_at": "2025-12-11T10:17:04.914000"
  },
  {
    "id": "f5e81ecd-ca60-405b-b3c3-fc8b97ae4af4",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Forever 21. Shop now and save big!",
    "code": "SHOP25",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "dffc8586-281a-4b6b-9569-6df6aa53a093",
    "store_name": "Forever 21",
    "store_domain": "forever21.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$5.00",
    "featured": false,
    "expiry_date": "2026-01-24",
    "logo": "https://www.google.com/s2/favicons?domain=forever21.com&sz=128",
    "created_at": "2025-12-11T10:17:04.915000"
  },
  {
    "id": "fd872f47-a31d-4ec9-bd20-358413b79d56",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Forever 21. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "dffc8586-281a-4b6b-9569-6df6aa53a093",
    "store_name": "Forever 21",
    "store_domain": "forever21.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-23",
    "logo": "https://www.google.com/s2/favicons?domain=forever21.com&sz=128",
    "created_at": "2025-12-11T10:17:04.915000"
  },
  {
    "id": "fd3dd732-cf7c-4cc0-8622-3a6361dc9c9a",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Forever 21. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "dffc8586-281a-4b6b-9569-6df6aa53a093",
    "store_name": "Forever 21",
    "store_domain": "forever21.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-28",
    "logo": "https://www.google.com/s2/favicons?domain=forever21.com&sz=128",
    "created_at": "2025-12-11T10:17:04.916000"
  },
  {
    "id": "9f40f073-59b5-4682-a6f0-0564d6330857",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Forever 21. Shop now and save big!",
    "code": "SAVE91",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "dffc8586-281a-4b6b-9569-6df6aa53a093",
    "store_name": "Forever 21",
    "store_domain": "forever21.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$23.00",
    "featured": false,
    "expiry_date": "2026-03-07",
    "logo": "https://www.google.com/s2/favicons?domain=forever21.com&sz=128",
    "created_at": "2025-12-11T10:17:04.917000"
  },
  {
    "id": "dac8a4ac-f4b5-4ab0-a377-c41ec6d95aac",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Forever 21. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "dffc8586-281a-4b6b-9569-6df6aa53a093",
    "store_name": "Forever 21",
    "store_domain": "forever21.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-23",
    "logo": "https://www.google.com/s2/favicons?domain=forever21.com&sz=128",
    "created_at": "2025-12-11T10:17:04.917000"
  },
  {
    "id": "eada4545-a914-4ea8-a20b-61aae7f6c510",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Forever 21. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "dffc8586-281a-4b6b-9569-6df6aa53a093",
    "store_name": "Forever 21",
    "store_domain": "forever21.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2025-12-26",
    "logo": "https://www.google.com/s2/favicons?domain=forever21.com&sz=128",
    "created_at": "2025-12-11T10:17:04.917000"
  },
  {
    "id": "1b30bf86-0eeb-42e1-91c8-2c5934b6e1b3",
    "title": "Buy 2 Get 1 Free on Select Items",
    "description": "Get 50% off on your purchase at Forever 21. Shop now and save big!",
    "code": "GET80",
    "discount": "50% OFF",
    "type": "code",
    "store_id": "dffc8586-281a-4b6b-9569-6df6aa53a093",
    "store_name": "Forever 21",
    "store_domain": "forever21.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$8.00",
    "featured": false,
    "expiry_date": "2026-02-18",
    "logo": "https://www.google.com/s2/favicons?domain=forever21.com&sz=128",
    "created_at": "2025-12-11T10:17:04.918000"
  },
  {
    "id": "caa31a46-fe62-4df8-a0a7-6c3f20c25d29",
    "title": "Clearance Sale: Up to $75 off Off",
    "description": "Get $75 off on your purchase at Forever 21. Shop now and save big!",
    "code": null,
    "discount": "$75 OFF",
    "type": "deal",
    "store_id": "dffc8586-281a-4b6b-9569-6df6aa53a093",
    "store_name": "Forever 21",
    "store_domain": "forever21.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-08",
    "logo": "https://www.google.com/s2/favicons?domain=forever21.com&sz=128",
    "created_at": "2025-12-11T10:17:04.918000"
  },
  {
    "id": "df065119-42f7-427d-a14b-4986912e9b34",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Expedia. Shop now and save big!",
    "code": "SHOP84",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "a8904b02-da76-4da6-b455-d8789318f913",
    "store_name": "Expedia",
    "store_domain": "expedia.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$18.00",
    "featured": true,
    "expiry_date": "2026-02-16",
    "logo": "https://www.google.com/s2/favicons?domain=expedia.com&sz=128",
    "created_at": "2025-12-11T10:17:04.919000"
  },
  {
    "id": "4bb71ec3-e2ea-4376-a895-ad7dcc5f202c",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Expedia. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "a8904b02-da76-4da6-b455-d8789318f913",
    "store_name": "Expedia",
    "store_domain": "expedia.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-05",
    "logo": "https://www.google.com/s2/favicons?domain=expedia.com&sz=128",
    "created_at": "2025-12-11T10:17:04.919000"
  },
  {
    "id": "e53cdd3b-d6af-4596-b2b3-1b94e8148a4e",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Expedia. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "a8904b02-da76-4da6-b455-d8789318f913",
    "store_name": "Expedia",
    "store_domain": "expedia.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2025-12-26",
    "logo": "https://www.google.com/s2/favicons?domain=expedia.com&sz=128",
    "created_at": "2025-12-11T10:17:04.919000"
  },
  {
    "id": "c6f1692e-abf3-40a9-9160-b8ffe695ba1f",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Expedia. Shop now and save big!",
    "code": "WELCOME21",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "a8904b02-da76-4da6-b455-d8789318f913",
    "store_name": "Expedia",
    "store_domain": "expedia.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$18.00",
    "featured": false,
    "expiry_date": "2026-02-14",
    "logo": "https://www.google.com/s2/favicons?domain=expedia.com&sz=128",
    "created_at": "2025-12-11T10:17:04.920000"
  },
  {
    "id": "9a7dfc50-c35d-4737-8e4a-29c32d0a137a",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Expedia. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "a8904b02-da76-4da6-b455-d8789318f913",
    "store_name": "Expedia",
    "store_domain": "expedia.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-12",
    "logo": "https://www.google.com/s2/favicons?domain=expedia.com&sz=128",
    "created_at": "2025-12-11T10:17:04.920000"
  },
  {
    "id": "4db80d19-9743-46c0-9854-82d62a465475",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Hotels.com. Shop now and save big!",
    "code": "HOT76",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "a8d92aa7-0ebc-4ae5-b395-2565636bcbc5",
    "store_name": "Hotels.com",
    "store_domain": "hotels.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$69.00",
    "featured": false,
    "expiry_date": "2026-03-05",
    "logo": "https://www.google.com/s2/favicons?domain=hotels.com&sz=128",
    "created_at": "2025-12-11T10:17:04.921000"
  },
  {
    "id": "b113e1ab-ae72-4a54-a504-40d12a701c24",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Hotels.com. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "a8d92aa7-0ebc-4ae5-b395-2565636bcbc5",
    "store_name": "Hotels.com",
    "store_domain": "hotels.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2026-01-27",
    "logo": "https://www.google.com/s2/favicons?domain=hotels.com&sz=128",
    "created_at": "2025-12-11T10:17:04.921000"
  },
  {
    "id": "ebf3d1cc-73fc-4f7c-94f2-f05cd21e0e0b",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Hotels.com. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "a8d92aa7-0ebc-4ae5-b395-2565636bcbc5",
    "store_name": "Hotels.com",
    "store_domain": "hotels.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2026-03-08",
    "logo": "https://www.google.com/s2/favicons?domain=hotels.com&sz=128",
    "created_at": "2025-12-11T10:17:04.921000"
  },
  {
    "id": "d7a56153-35a8-494c-8c8b-5cd7645fbee4",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Hotels.com. Shop now and save big!",
    "code": "TBKN62",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "a8d92aa7-0ebc-4ae5-b395-2565636bcbc5",
    "store_name": "Hotels.com",
    "store_domain": "hotels.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$73.00",
    "featured": false,
    "expiry_date": "2026-01-09",
    "logo": "https://www.google.com/s2/favicons?domain=hotels.com&sz=128",
    "created_at": "2025-12-11T10:17:04.921000"
  },
  {
    "id": "68467fa8-cd22-404d-b51e-7379f4211309",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Hotels.com. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "a8d92aa7-0ebc-4ae5-b395-2565636bcbc5",
    "store_name": "Hotels.com",
    "store_domain": "hotels.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-07",
    "logo": "https://www.google.com/s2/favicons?domain=hotels.com&sz=128",
    "created_at": "2025-12-11T10:17:04.922000"
  },
  {
    "id": "f5c2fd3c-08a8-4339-b614-c51369fb813b",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Hotels.com. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "a8d92aa7-0ebc-4ae5-b395-2565636bcbc5",
    "store_name": "Hotels.com",
    "store_domain": "hotels.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-06",
    "logo": "https://www.google.com/s2/favicons?domain=hotels.com&sz=128",
    "created_at": "2025-12-11T10:17:04.922000"
  },
  {
    "id": "eb446ca7-1c04-47a1-aac3-c6a750664fde",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at GoDaddy. Shop now and save big!",
    "code": "FUWX26",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "04725598-0f5e-43c4-bd14-4fea9a30db91",
    "store_name": "GoDaddy",
    "store_domain": "godaddy.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$73.00",
    "featured": false,
    "expiry_date": "2026-03-10",
    "logo": "https://www.google.com/s2/favicons?domain=godaddy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.923000"
  },
  {
    "id": "a852244c-1c76-4f85-b5ad-5141bcb161db",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at GoDaddy. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "04725598-0f5e-43c4-bd14-4fea9a30db91",
    "store_name": "GoDaddy",
    "store_domain": "godaddy.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-30",
    "logo": "https://www.google.com/s2/favicons?domain=godaddy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.923000"
  },
  {
    "id": "05f4743d-92ee-4049-8fb7-d8a9bac2f5e4",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at GoDaddy. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "04725598-0f5e-43c4-bd14-4fea9a30db91",
    "store_name": "GoDaddy",
    "store_domain": "godaddy.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-19",
    "logo": "https://www.google.com/s2/favicons?domain=godaddy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.923000"
  },
  {
    "id": "0efb172c-9df1-47a1-805e-08586e7da7ae",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at GoDaddy. Shop now and save big!",
    "code": "HBDY79",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "04725598-0f5e-43c4-bd14-4fea9a30db91",
    "store_name": "GoDaddy",
    "store_domain": "godaddy.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$52.00",
    "featured": true,
    "expiry_date": "2026-01-07",
    "logo": "https://www.google.com/s2/favicons?domain=godaddy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.923000"
  },
  {
    "id": "ccebbde6-109c-4773-815b-6aec03ab057f",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at GoDaddy. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "04725598-0f5e-43c4-bd14-4fea9a30db91",
    "store_name": "GoDaddy",
    "store_domain": "godaddy.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-06",
    "logo": "https://www.google.com/s2/favicons?domain=godaddy.com&sz=128",
    "created_at": "2025-12-11T10:17:04.924000"
  },
  {
    "id": "f9907455-0362-43f7-949c-5df844dc29c9",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at H&M. Shop now and save big!",
    "code": "DEALM71",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "818943b8-e777-4a6d-949d-dc5f0aa7597a",
    "store_name": "H&M",
    "store_domain": "hm.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$9.00",
    "featured": true,
    "expiry_date": "2026-01-11",
    "logo": "https://www.google.com/s2/favicons?domain=hm.com&sz=128",
    "created_at": "2025-12-11T10:45:32.840000"
  },
  {
    "id": "1c583d77-4778-4df2-9682-d4474aaedfc3",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at H&M. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "818943b8-e777-4a6d-949d-dc5f0aa7597a",
    "store_name": "H&M",
    "store_domain": "hm.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-28",
    "logo": "https://www.google.com/s2/favicons?domain=hm.com&sz=128",
    "created_at": "2025-12-11T10:45:32.840000"
  },
  {
    "id": "accfac85-5b97-48e5-bd0c-b10d0a84a5c4",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at H&M. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "818943b8-e777-4a6d-949d-dc5f0aa7597a",
    "store_name": "H&M",
    "store_domain": "hm.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-03",
    "logo": "https://www.google.com/s2/favicons?domain=hm.com&sz=128",
    "created_at": "2025-12-11T10:45:32.841000"
  },
  {
    "id": "9fefa3f5-28ea-4703-9363-6dfd6f20a74f",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at H&M. Shop now and save big!",
    "code": "H&M26",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "818943b8-e777-4a6d-949d-dc5f0aa7597a",
    "store_name": "H&M",
    "store_domain": "hm.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$52.00",
    "featured": false,
    "expiry_date": "2025-12-26",
    "logo": "https://www.google.com/s2/favicons?domain=hm.com&sz=128",
    "created_at": "2025-12-11T10:45:32.841000"
  },
  {
    "id": "b7eee909-274e-4c7c-a163-0b0189eb9e54",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at H&M. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "818943b8-e777-4a6d-949d-dc5f0aa7597a",
    "store_name": "H&M",
    "store_domain": "hm.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-25",
    "logo": "https://www.google.com/s2/favicons?domain=hm.com&sz=128",
    "created_at": "2025-12-11T10:45:32.841000"
  },
  {
    "id": "37010926-2316-45d7-b73b-f108af7853f5",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at H&M. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "818943b8-e777-4a6d-949d-dc5f0aa7597a",
    "store_name": "H&M",
    "store_domain": "hm.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-19",
    "logo": "https://www.google.com/s2/favicons?domain=hm.com&sz=128",
    "created_at": "2025-12-11T10:45:32.841000"
  },
  {
    "id": "216a2b05-755d-4233-923a-921a76c6c139",
    "title": "Buy 2 Get 1 Free on Select Items",
    "description": "Get 50% off on your purchase at H&M. Shop now and save big!",
    "code": "UVVF63",
    "discount": "50% OFF",
    "type": "code",
    "store_id": "818943b8-e777-4a6d-949d-dc5f0aa7597a",
    "store_name": "H&M",
    "store_domain": "hm.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$50.00",
    "featured": false,
    "expiry_date": "2025-12-30",
    "logo": "https://www.google.com/s2/favicons?domain=hm.com&sz=128",
    "created_at": "2025-12-11T10:45:32.842000"
  },
  {
    "id": "f29a2f10-d008-4aba-8f26-bf372392242f",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Zara. Shop now and save big!",
    "code": "DEALO71",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "80a88086-37ba-4571-8a36-09e0d467bff9",
    "store_name": "Zara",
    "store_domain": "zara.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$29.00",
    "featured": false,
    "expiry_date": "2026-01-23",
    "logo": "https://www.google.com/s2/favicons?domain=zara.com&sz=128",
    "created_at": "2025-12-11T10:45:32.843000"
  },
  {
    "id": "0567938f-7df9-42d6-a4cb-2cb5779dade8",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Zara. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "80a88086-37ba-4571-8a36-09e0d467bff9",
    "store_name": "Zara",
    "store_domain": "zara.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-03",
    "logo": "https://www.google.com/s2/favicons?domain=zara.com&sz=128",
    "created_at": "2025-12-11T10:45:32.843000"
  },
  {
    "id": "407e7f07-a85a-42a9-99f6-da49244761c4",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Zara. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "80a88086-37ba-4571-8a36-09e0d467bff9",
    "store_name": "Zara",
    "store_domain": "zara.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-16",
    "logo": "https://www.google.com/s2/favicons?domain=zara.com&sz=128",
    "created_at": "2025-12-11T10:45:32.843000"
  },
  {
    "id": "2a2fa653-a234-48d0-92b5-3b8f5172f21e",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Zara. Shop now and save big!",
    "code": "JOSS10",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "80a88086-37ba-4571-8a36-09e0d467bff9",
    "store_name": "Zara",
    "store_domain": "zara.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$64.00",
    "featured": false,
    "expiry_date": "2026-01-09",
    "logo": "https://www.google.com/s2/favicons?domain=zara.com&sz=128",
    "created_at": "2025-12-11T10:45:32.843000"
  },
  {
    "id": "8888f443-a60e-4c82-859a-0d95427f58e2",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Zara. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "80a88086-37ba-4571-8a36-09e0d467bff9",
    "store_name": "Zara",
    "store_domain": "zara.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-14",
    "logo": "https://www.google.com/s2/favicons?domain=zara.com&sz=128",
    "created_at": "2025-12-11T10:45:32.844000"
  },
  {
    "id": "981a820e-9ea1-437b-8b0c-8285f76f340b",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Zara. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "80a88086-37ba-4571-8a36-09e0d467bff9",
    "store_name": "Zara",
    "store_domain": "zara.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-02",
    "logo": "https://www.google.com/s2/favicons?domain=zara.com&sz=128",
    "created_at": "2025-12-11T10:45:32.844000"
  },
  {
    "id": "86bb7722-2a5b-4d8b-a607-e61348679a75",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Uniqlo. Shop now and save big!",
    "code": "UNI34",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "6f95cfc6-7716-4cb3-b165-de83837e72f5",
    "store_name": "Uniqlo",
    "store_domain": "uniqlo.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$45.00",
    "featured": true,
    "expiry_date": "2026-03-07",
    "logo": "https://www.google.com/s2/favicons?domain=uniqlo.com&sz=128",
    "created_at": "2025-12-11T10:45:32.845000"
  },
  {
    "id": "09279fc0-37bd-4980-af92-66ab17ae3062",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Uniqlo. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "6f95cfc6-7716-4cb3-b165-de83837e72f5",
    "store_name": "Uniqlo",
    "store_domain": "uniqlo.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-25",
    "logo": "https://www.google.com/s2/favicons?domain=uniqlo.com&sz=128",
    "created_at": "2025-12-11T10:45:32.845000"
  },
  {
    "id": "24a60e4e-635b-4898-a3e7-11e4fa20aa2c",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Uniqlo. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "6f95cfc6-7716-4cb3-b165-de83837e72f5",
    "store_name": "Uniqlo",
    "store_domain": "uniqlo.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-04",
    "logo": "https://www.google.com/s2/favicons?domain=uniqlo.com&sz=128",
    "created_at": "2025-12-11T10:45:32.845000"
  },
  {
    "id": "776ee44e-f384-4807-9ff5-dce78ab1b5d4",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Uniqlo. Shop now and save big!",
    "code": "UNI67",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "6f95cfc6-7716-4cb3-b165-de83837e72f5",
    "store_name": "Uniqlo",
    "store_domain": "uniqlo.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$30.00",
    "featured": true,
    "expiry_date": "2026-01-08",
    "logo": "https://www.google.com/s2/favicons?domain=uniqlo.com&sz=128",
    "created_at": "2025-12-11T10:45:32.845000"
  },
  {
    "id": "f5dfefd3-89cb-4cd1-90d8-2e49cd945e90",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Uniqlo. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "6f95cfc6-7716-4cb3-b165-de83837e72f5",
    "store_name": "Uniqlo",
    "store_domain": "uniqlo.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-23",
    "logo": "https://www.google.com/s2/favicons?domain=uniqlo.com&sz=128",
    "created_at": "2025-12-11T10:45:32.845000"
  },
  {
    "id": "438f31b9-de90-44e2-ac29-06dd5e5022f9",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at American Eagle. Shop now and save big!",
    "code": "WELCOMET84",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "cbabb3f7-c867-46d0-b467-ba2e9a6f7fa5",
    "store_name": "American Eagle",
    "store_domain": "ae.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$12.00",
    "featured": false,
    "expiry_date": "2026-02-04",
    "logo": "https://www.google.com/s2/favicons?domain=ae.com&sz=128",
    "created_at": "2025-12-11T10:45:32.846000"
  },
  {
    "id": "00cffff4-ac45-4422-a2c7-e24c0676612e",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at American Eagle. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "cbabb3f7-c867-46d0-b467-ba2e9a6f7fa5",
    "store_name": "American Eagle",
    "store_domain": "ae.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2025-12-28",
    "logo": "https://www.google.com/s2/favicons?domain=ae.com&sz=128",
    "created_at": "2025-12-11T10:45:32.846000"
  },
  {
    "id": "17914f30-e115-40b8-83a2-a9ffd47e4c68",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at American Eagle. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "cbabb3f7-c867-46d0-b467-ba2e9a6f7fa5",
    "store_name": "American Eagle",
    "store_domain": "ae.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-05",
    "logo": "https://www.google.com/s2/favicons?domain=ae.com&sz=128",
    "created_at": "2025-12-11T10:45:32.847000"
  },
  {
    "id": "805c21a0-f534-4305-9234-c1665e9d31fd",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at American Eagle. Shop now and save big!",
    "code": "AME33",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "cbabb3f7-c867-46d0-b467-ba2e9a6f7fa5",
    "store_name": "American Eagle",
    "store_domain": "ae.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$79.00",
    "featured": false,
    "expiry_date": "2026-02-09",
    "logo": "https://www.google.com/s2/favicons?domain=ae.com&sz=128",
    "created_at": "2025-12-11T10:45:32.847000"
  },
  {
    "id": "2754b091-b335-4cb9-8d69-e81040630bac",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at American Eagle. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "cbabb3f7-c867-46d0-b467-ba2e9a6f7fa5",
    "store_name": "American Eagle",
    "store_domain": "ae.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-02",
    "logo": "https://www.google.com/s2/favicons?domain=ae.com&sz=128",
    "created_at": "2025-12-11T10:45:32.847000"
  },
  {
    "id": "a973d91a-4c65-4bce-b714-7845ccdca5d1",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at American Eagle. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "cbabb3f7-c867-46d0-b467-ba2e9a6f7fa5",
    "store_name": "American Eagle",
    "store_domain": "ae.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-14",
    "logo": "https://www.google.com/s2/favicons?domain=ae.com&sz=128",
    "created_at": "2025-12-11T10:45:32.847000"
  },
  {
    "id": "5ffd6631-0806-41b6-a74d-a959e2b57939",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Hollister. Shop now and save big!",
    "code": "WELCOME81",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "8a7223c2-0337-4a7f-bd7e-6a27634fb8d1",
    "store_name": "Hollister",
    "store_domain": "hollisterco.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$98.00",
    "featured": true,
    "expiry_date": "2025-12-30",
    "logo": "https://www.google.com/s2/favicons?domain=hollisterco.com&sz=128",
    "created_at": "2025-12-11T10:45:32.848000"
  },
  {
    "id": "a16c1286-9081-408e-bbf1-1f8030d35ad3",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Hollister. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "8a7223c2-0337-4a7f-bd7e-6a27634fb8d1",
    "store_name": "Hollister",
    "store_domain": "hollisterco.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-25",
    "logo": "https://www.google.com/s2/favicons?domain=hollisterco.com&sz=128",
    "created_at": "2025-12-11T10:45:32.848000"
  },
  {
    "id": "ee7bdab4-b52d-4c91-a519-1c5e9bc77076",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Hollister. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "8a7223c2-0337-4a7f-bd7e-6a27634fb8d1",
    "store_name": "Hollister",
    "store_domain": "hollisterco.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-24",
    "logo": "https://www.google.com/s2/favicons?domain=hollisterco.com&sz=128",
    "created_at": "2025-12-11T10:45:32.848000"
  },
  {
    "id": "8bc851af-741c-4afb-96aa-182090cfa2bb",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Hollister. Shop now and save big!",
    "code": "GETN15",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "8a7223c2-0337-4a7f-bd7e-6a27634fb8d1",
    "store_name": "Hollister",
    "store_domain": "hollisterco.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$33.00",
    "featured": false,
    "expiry_date": "2026-01-13",
    "logo": "https://www.google.com/s2/favicons?domain=hollisterco.com&sz=128",
    "created_at": "2025-12-11T10:45:32.849000"
  },
  {
    "id": "ccf7263d-7e1c-48cb-beaa-1e38488449cd",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Hollister. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "8a7223c2-0337-4a7f-bd7e-6a27634fb8d1",
    "store_name": "Hollister",
    "store_domain": "hollisterco.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-03",
    "logo": "https://www.google.com/s2/favicons?domain=hollisterco.com&sz=128",
    "created_at": "2025-12-11T10:45:32.849000"
  },
  {
    "id": "a081593b-a310-4df3-a4fb-76121ede8406",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Hollister. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "8a7223c2-0337-4a7f-bd7e-6a27634fb8d1",
    "store_name": "Hollister",
    "store_domain": "hollisterco.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-23",
    "logo": "https://www.google.com/s2/favicons?domain=hollisterco.com&sz=128",
    "created_at": "2025-12-11T10:45:32.849000"
  },
  {
    "id": "f45b4cd4-5579-4ef4-bec2-08244baccf39",
    "title": "Buy 2 Get 1 Free on Select Items",
    "description": "Get 50% off on your purchase at Hollister. Shop now and save big!",
    "code": "WMIR65",
    "discount": "50% OFF",
    "type": "code",
    "store_id": "8a7223c2-0337-4a7f-bd7e-6a27634fb8d1",
    "store_name": "Hollister",
    "store_domain": "hollisterco.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$34.00",
    "featured": false,
    "expiry_date": "2026-02-10",
    "logo": "https://www.google.com/s2/favicons?domain=hollisterco.com&sz=128",
    "created_at": "2025-12-11T10:45:32.849000"
  },
  {
    "id": "2d4ee06a-d5ae-430a-81db-a1a83dda76af",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Abercrombie & Fitch. Shop now and save big!",
    "code": "ABE37",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "d9e6eaa0-7790-440f-9318-814243eaa8f8",
    "store_name": "Abercrombie & Fitch",
    "store_domain": "abercrombie.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$22.00",
    "featured": false,
    "expiry_date": "2026-01-04",
    "logo": "https://www.google.com/s2/favicons?domain=abercrombie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.850000"
  },
  {
    "id": "ca943204-26e8-451d-b578-4dd1d2de11db",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Abercrombie & Fitch. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "d9e6eaa0-7790-440f-9318-814243eaa8f8",
    "store_name": "Abercrombie & Fitch",
    "store_domain": "abercrombie.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-11",
    "logo": "https://www.google.com/s2/favicons?domain=abercrombie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.850000"
  },
  {
    "id": "e7c40aa0-8879-43aa-b173-e264aef94f44",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Abercrombie & Fitch. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "d9e6eaa0-7790-440f-9318-814243eaa8f8",
    "store_name": "Abercrombie & Fitch",
    "store_domain": "abercrombie.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-03",
    "logo": "https://www.google.com/s2/favicons?domain=abercrombie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.850000"
  },
  {
    "id": "cee4853a-7a06-45a2-ae1b-71256741bdbb",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Abercrombie & Fitch. Shop now and save big!",
    "code": "EXTRAX18",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "d9e6eaa0-7790-440f-9318-814243eaa8f8",
    "store_name": "Abercrombie & Fitch",
    "store_domain": "abercrombie.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$8.00",
    "featured": false,
    "expiry_date": "2026-01-26",
    "logo": "https://www.google.com/s2/favicons?domain=abercrombie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.851000"
  },
  {
    "id": "c554ce72-761b-4ff2-91ac-4f11830cf79c",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Abercrombie & Fitch. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "d9e6eaa0-7790-440f-9318-814243eaa8f8",
    "store_name": "Abercrombie & Fitch",
    "store_domain": "abercrombie.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-17",
    "logo": "https://www.google.com/s2/favicons?domain=abercrombie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.851000"
  },
  {
    "id": "10878e42-61b9-44a6-8512-781db579a9f5",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Urban Outfitters. Shop now and save big!",
    "code": "URB27",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "f9bdd9ae-21e2-4237-a3ea-dd4da6ef5adc",
    "store_name": "Urban Outfitters",
    "store_domain": "urbanoutfitters.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$68.00",
    "featured": false,
    "expiry_date": "2026-01-06",
    "logo": "https://www.google.com/s2/favicons?domain=urbanoutfitters.com&sz=128",
    "created_at": "2025-12-11T10:45:32.852000"
  },
  {
    "id": "7b259d66-2215-4c42-b36f-1ba43fd29995",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Urban Outfitters. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "f9bdd9ae-21e2-4237-a3ea-dd4da6ef5adc",
    "store_name": "Urban Outfitters",
    "store_domain": "urbanoutfitters.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-15",
    "logo": "https://www.google.com/s2/favicons?domain=urbanoutfitters.com&sz=128",
    "created_at": "2025-12-11T10:45:32.852000"
  },
  {
    "id": "1623e450-288d-4e09-845b-f638d695798d",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Urban Outfitters. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "f9bdd9ae-21e2-4237-a3ea-dd4da6ef5adc",
    "store_name": "Urban Outfitters",
    "store_domain": "urbanoutfitters.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-31",
    "logo": "https://www.google.com/s2/favicons?domain=urbanoutfitters.com&sz=128",
    "created_at": "2025-12-11T10:45:32.852000"
  },
  {
    "id": "af234ec5-2a48-478f-b75e-1d3b4fe5d8bf",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Urban Outfitters. Shop now and save big!",
    "code": "URB47",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "f9bdd9ae-21e2-4237-a3ea-dd4da6ef5adc",
    "store_name": "Urban Outfitters",
    "store_domain": "urbanoutfitters.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$64.00",
    "featured": false,
    "expiry_date": "2026-01-02",
    "logo": "https://www.google.com/s2/favicons?domain=urbanoutfitters.com&sz=128",
    "created_at": "2025-12-11T10:45:32.852000"
  },
  {
    "id": "14b6ad70-e7c7-4e35-bfde-4ffec79e75b9",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Urban Outfitters. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "f9bdd9ae-21e2-4237-a3ea-dd4da6ef5adc",
    "store_name": "Urban Outfitters",
    "store_domain": "urbanoutfitters.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-01",
    "logo": "https://www.google.com/s2/favicons?domain=urbanoutfitters.com&sz=128",
    "created_at": "2025-12-11T10:45:32.852000"
  },
  {
    "id": "5bc4d8ff-06f5-4914-9515-ccef9b87a440",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Urban Outfitters. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "f9bdd9ae-21e2-4237-a3ea-dd4da6ef5adc",
    "store_name": "Urban Outfitters",
    "store_domain": "urbanoutfitters.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-21",
    "logo": "https://www.google.com/s2/favicons?domain=urbanoutfitters.com&sz=128",
    "created_at": "2025-12-11T10:45:32.853000"
  },
  {
    "id": "7860fc85-489a-4e23-9cf6-3066a27642c0",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Anthropologie. Shop now and save big!",
    "code": "WELCOMEA71",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "fc82f624-2088-4bac-8c77-b7de927e6664",
    "store_name": "Anthropologie",
    "store_domain": "anthropologie.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$34.00",
    "featured": false,
    "expiry_date": "2026-01-18",
    "logo": "https://www.google.com/s2/favicons?domain=anthropologie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.854000"
  },
  {
    "id": "8847bfcf-df62-466b-a115-8dbb394f2d2b",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Anthropologie. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "fc82f624-2088-4bac-8c77-b7de927e6664",
    "store_name": "Anthropologie",
    "store_domain": "anthropologie.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-12",
    "logo": "https://www.google.com/s2/favicons?domain=anthropologie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.854000"
  },
  {
    "id": "1fd00a93-4208-4afc-9c39-a6a027630888",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Anthropologie. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "fc82f624-2088-4bac-8c77-b7de927e6664",
    "store_name": "Anthropologie",
    "store_domain": "anthropologie.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-27",
    "logo": "https://www.google.com/s2/favicons?domain=anthropologie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.854000"
  },
  {
    "id": "04e31ff8-608e-4343-8b00-b23775e2ec40",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Anthropologie. Shop now and save big!",
    "code": "DEAL54",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "fc82f624-2088-4bac-8c77-b7de927e6664",
    "store_name": "Anthropologie",
    "store_domain": "anthropologie.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$66.00",
    "featured": true,
    "expiry_date": "2026-01-15",
    "logo": "https://www.google.com/s2/favicons?domain=anthropologie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.854000"
  },
  {
    "id": "1478fbd7-7335-45c4-a118-0ab59fd505c4",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Anthropologie. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "fc82f624-2088-4bac-8c77-b7de927e6664",
    "store_name": "Anthropologie",
    "store_domain": "anthropologie.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2026-03-10",
    "logo": "https://www.google.com/s2/favicons?domain=anthropologie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.854000"
  },
  {
    "id": "40ea448b-3fd3-40dd-9617-861d9f98a29d",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Anthropologie. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "fc82f624-2088-4bac-8c77-b7de927e6664",
    "store_name": "Anthropologie",
    "store_domain": "anthropologie.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-09",
    "logo": "https://www.google.com/s2/favicons?domain=anthropologie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.854000"
  },
  {
    "id": "5fe6d414-c955-4187-98c1-bd93ab14ddb0",
    "title": "Buy 2 Get 1 Free on Select Items",
    "description": "Get 50% off on your purchase at Anthropologie. Shop now and save big!",
    "code": "AAQF32",
    "discount": "50% OFF",
    "type": "code",
    "store_id": "fc82f624-2088-4bac-8c77-b7de927e6664",
    "store_name": "Anthropologie",
    "store_domain": "anthropologie.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$72.00",
    "featured": false,
    "expiry_date": "2026-02-06",
    "logo": "https://www.google.com/s2/favicons?domain=anthropologie.com&sz=128",
    "created_at": "2025-12-11T10:45:32.855000"
  },
  {
    "id": "610a27d6-35d0-418f-a577-b6d12d182fa8",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Free People. Shop now and save big!",
    "code": "FRE93",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "056996f3-dafb-483d-92c2-33bfc5b868da",
    "store_name": "Free People",
    "store_domain": "freepeople.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$65.00",
    "featured": false,
    "expiry_date": "2026-01-06",
    "logo": "https://www.google.com/s2/favicons?domain=freepeople.com&sz=128",
    "created_at": "2025-12-11T10:45:32.855000"
  },
  {
    "id": "8653a805-72c5-488d-b82b-5bf6eafb3b97",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Free People. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "056996f3-dafb-483d-92c2-33bfc5b868da",
    "store_name": "Free People",
    "store_domain": "freepeople.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2026-02-28",
    "logo": "https://www.google.com/s2/favicons?domain=freepeople.com&sz=128",
    "created_at": "2025-12-11T10:45:32.856000"
  },
  {
    "id": "9b42f524-1d0d-4882-8203-54b179c1fc59",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Free People. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "056996f3-dafb-483d-92c2-33bfc5b868da",
    "store_name": "Free People",
    "store_domain": "freepeople.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-06",
    "logo": "https://www.google.com/s2/favicons?domain=freepeople.com&sz=128",
    "created_at": "2025-12-11T10:45:32.856000"
  },
  {
    "id": "e4f5e54f-e0a4-4e04-95b0-c673eaf2bdf3",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Free People. Shop now and save big!",
    "code": "FRE66",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "056996f3-dafb-483d-92c2-33bfc5b868da",
    "store_name": "Free People",
    "store_domain": "freepeople.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$28.00",
    "featured": false,
    "expiry_date": "2026-02-01",
    "logo": "https://www.google.com/s2/favicons?domain=freepeople.com&sz=128",
    "created_at": "2025-12-11T10:45:32.856000"
  },
  {
    "id": "56d25f41-d490-4b93-a180-ce1a11fcf998",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Free People. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "056996f3-dafb-483d-92c2-33bfc5b868da",
    "store_name": "Free People",
    "store_domain": "freepeople.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-25",
    "logo": "https://www.google.com/s2/favicons?domain=freepeople.com&sz=128",
    "created_at": "2025-12-11T10:45:32.856000"
  },
  {
    "id": "091b510f-0bd1-4ebe-af60-90cc94b680f8",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Free People. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "056996f3-dafb-483d-92c2-33bfc5b868da",
    "store_name": "Free People",
    "store_domain": "freepeople.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-01",
    "logo": "https://www.google.com/s2/favicons?domain=freepeople.com&sz=128",
    "created_at": "2025-12-11T10:45:32.856000"
  },
  {
    "id": "c6b336fb-136c-4d36-91a2-c0ace104d336",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Lululemon. Shop now and save big!",
    "code": "LUL82",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "232f03dc-d1cc-40f4-900e-58cc25e7820e",
    "store_name": "Lululemon",
    "store_domain": "lululemon.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$15.00",
    "featured": false,
    "expiry_date": "2026-02-17",
    "logo": "https://www.google.com/s2/favicons?domain=lululemon.com&sz=128",
    "created_at": "2025-12-11T10:45:32.857000"
  },
  {
    "id": "db9ca786-3eb9-4d56-b569-4677aa6d0e39",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Lululemon. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "232f03dc-d1cc-40f4-900e-58cc25e7820e",
    "store_name": "Lululemon",
    "store_domain": "lululemon.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-17",
    "logo": "https://www.google.com/s2/favicons?domain=lululemon.com&sz=128",
    "created_at": "2025-12-11T10:45:32.857000"
  },
  {
    "id": "3005040e-b734-4041-b875-41c6522647c7",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Lululemon. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "232f03dc-d1cc-40f4-900e-58cc25e7820e",
    "store_name": "Lululemon",
    "store_domain": "lululemon.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-08",
    "logo": "https://www.google.com/s2/favicons?domain=lululemon.com&sz=128",
    "created_at": "2025-12-11T10:45:32.858000"
  },
  {
    "id": "82301393-26f1-4e05-a41b-a8ca9f70aec2",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Lululemon. Shop now and save big!",
    "code": "LUL44",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "232f03dc-d1cc-40f4-900e-58cc25e7820e",
    "store_name": "Lululemon",
    "store_domain": "lululemon.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$79.00",
    "featured": false,
    "expiry_date": "2026-03-03",
    "logo": "https://www.google.com/s2/favicons?domain=lululemon.com&sz=128",
    "created_at": "2025-12-11T10:45:32.858000"
  },
  {
    "id": "f1cb4c59-7f67-4cff-8745-5f0fa8c9df7d",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Lululemon. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "232f03dc-d1cc-40f4-900e-58cc25e7820e",
    "store_name": "Lululemon",
    "store_domain": "lululemon.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-27",
    "logo": "https://www.google.com/s2/favicons?domain=lululemon.com&sz=128",
    "created_at": "2025-12-11T10:45:32.858000"
  },
  {
    "id": "08aedd80-a197-427f-b9b5-ef156418b0ed",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Lululemon. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "232f03dc-d1cc-40f4-900e-58cc25e7820e",
    "store_name": "Lululemon",
    "store_domain": "lululemon.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-19",
    "logo": "https://www.google.com/s2/favicons?domain=lululemon.com&sz=128",
    "created_at": "2025-12-11T10:45:32.858000"
  },
  {
    "id": "2abd571b-3643-46a3-87fb-6508d22c327d",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at J.Crew. Shop now and save big!",
    "code": "GET90",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "f00129a3-3ac8-4650-9c46-0c8d19223b10",
    "store_name": "J.Crew",
    "store_domain": "jcrew.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$6.00",
    "featured": false,
    "expiry_date": "2026-02-26",
    "logo": "https://www.google.com/s2/favicons?domain=jcrew.com&sz=128",
    "created_at": "2025-12-11T10:45:32.860000"
  },
  {
    "id": "426f4ed3-4dcf-4a3d-a4cf-450a117f7656",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at J.Crew. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "f00129a3-3ac8-4650-9c46-0c8d19223b10",
    "store_name": "J.Crew",
    "store_domain": "jcrew.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-02",
    "logo": "https://www.google.com/s2/favicons?domain=jcrew.com&sz=128",
    "created_at": "2025-12-11T10:45:32.860000"
  },
  {
    "id": "bbf8968b-b394-404a-ab8c-bbba13354107",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at J.Crew. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "f00129a3-3ac8-4650-9c46-0c8d19223b10",
    "store_name": "J.Crew",
    "store_domain": "jcrew.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2026-02-13",
    "logo": "https://www.google.com/s2/favicons?domain=jcrew.com&sz=128",
    "created_at": "2025-12-11T10:45:32.860000"
  },
  {
    "id": "7471f9e4-014a-417d-b7ae-96ae28eb6138",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at J.Crew. Shop now and save big!",
    "code": "J.C29",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "f00129a3-3ac8-4650-9c46-0c8d19223b10",
    "store_name": "J.Crew",
    "store_domain": "jcrew.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$11.00",
    "featured": false,
    "expiry_date": "2026-01-09",
    "logo": "https://www.google.com/s2/favicons?domain=jcrew.com&sz=128",
    "created_at": "2025-12-11T10:45:32.860000"
  },
  {
    "id": "f53d4cb9-d5ff-4fa1-8678-3dac81a7b5d4",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at J.Crew. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "f00129a3-3ac8-4650-9c46-0c8d19223b10",
    "store_name": "J.Crew",
    "store_domain": "jcrew.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-01",
    "logo": "https://www.google.com/s2/favicons?domain=jcrew.com&sz=128",
    "created_at": "2025-12-11T10:45:32.860000"
  },
  {
    "id": "e4c26497-456d-495c-94b2-71331c1ec328",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Banana Republic. Shop now and save big!",
    "code": "LSCN66",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "ff318e97-379b-4585-a5f6-70eb56385c57",
    "store_name": "Banana Republic",
    "store_domain": "bananarepublic.gap.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$64.00",
    "featured": false,
    "expiry_date": "2026-01-14",
    "logo": "https://www.google.com/s2/favicons?domain=bananarepublic.gap.com&sz=128",
    "created_at": "2025-12-11T10:45:32.861000"
  },
  {
    "id": "82682b23-a9c9-4569-9022-43494b5391fa",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Banana Republic. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "ff318e97-379b-4585-a5f6-70eb56385c57",
    "store_name": "Banana Republic",
    "store_domain": "bananarepublic.gap.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-01",
    "logo": "https://www.google.com/s2/favicons?domain=bananarepublic.gap.com&sz=128",
    "created_at": "2025-12-11T10:45:32.861000"
  },
  {
    "id": "98e0ca09-a2db-4dc4-b94a-1b530a8e5cbb",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Banana Republic. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "ff318e97-379b-4585-a5f6-70eb56385c57",
    "store_name": "Banana Republic",
    "store_domain": "bananarepublic.gap.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2026-02-22",
    "logo": "https://www.google.com/s2/favicons?domain=bananarepublic.gap.com&sz=128",
    "created_at": "2025-12-11T10:45:32.862000"
  },
  {
    "id": "5d4a20ad-f364-4453-bd9c-64ebae4f8feb",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Banana Republic. Shop now and save big!",
    "code": "DEAL54",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "ff318e97-379b-4585-a5f6-70eb56385c57",
    "store_name": "Banana Republic",
    "store_domain": "bananarepublic.gap.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$91.00",
    "featured": false,
    "expiry_date": "2026-01-14",
    "logo": "https://www.google.com/s2/favicons?domain=bananarepublic.gap.com&sz=128",
    "created_at": "2025-12-11T10:45:32.862000"
  },
  {
    "id": "68f9ea11-5a4c-41bf-a87b-e4142301d4cd",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Banana Republic. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "ff318e97-379b-4585-a5f6-70eb56385c57",
    "store_name": "Banana Republic",
    "store_domain": "bananarepublic.gap.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-10",
    "logo": "https://www.google.com/s2/favicons?domain=bananarepublic.gap.com&sz=128",
    "created_at": "2025-12-11T10:45:32.862000"
  },
  {
    "id": "3b86a284-2f9e-488b-88e2-40cec51872ce",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Banana Republic. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "ff318e97-379b-4585-a5f6-70eb56385c57",
    "store_name": "Banana Republic",
    "store_domain": "bananarepublic.gap.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-15",
    "logo": "https://www.google.com/s2/favicons?domain=bananarepublic.gap.com&sz=128",
    "created_at": "2025-12-11T10:45:32.862000"
  },
  {
    "id": "f6032922-51d8-4655-9eb5-52a41f7afd55",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Shein. Shop now and save big!",
    "code": "IPUH72",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "e812e2e1-101f-4050-8e5e-b60c93316f71",
    "store_name": "Shein",
    "store_domain": "shein.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$41.00",
    "featured": false,
    "expiry_date": "2026-01-02",
    "logo": "https://www.google.com/s2/favicons?domain=shein.com&sz=128",
    "created_at": "2025-12-11T11:10:13.561000"
  },
  {
    "id": "bf3407d4-cc39-428b-acb2-d676d4287f53",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Shein. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "e812e2e1-101f-4050-8e5e-b60c93316f71",
    "store_name": "Shein",
    "store_domain": "shein.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-02",
    "logo": "https://www.google.com/s2/favicons?domain=shein.com&sz=128",
    "created_at": "2025-12-11T11:10:13.561000"
  },
  {
    "id": "0c69e398-1d14-4fc1-82a6-169345c7d4fd",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Shein. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "e812e2e1-101f-4050-8e5e-b60c93316f71",
    "store_name": "Shein",
    "store_domain": "shein.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-10",
    "logo": "https://www.google.com/s2/favicons?domain=shein.com&sz=128",
    "created_at": "2025-12-11T11:10:13.562000"
  },
  {
    "id": "c41a5bb5-058d-493f-bbcb-dcf36fafd73b",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Shein. Shop now and save big!",
    "code": "EXTRA35",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "e812e2e1-101f-4050-8e5e-b60c93316f71",
    "store_name": "Shein",
    "store_domain": "shein.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$13.00",
    "featured": false,
    "expiry_date": "2026-02-20",
    "logo": "https://www.google.com/s2/favicons?domain=shein.com&sz=128",
    "created_at": "2025-12-11T11:10:13.562000"
  },
  {
    "id": "6c3649b5-c1ce-461d-8957-eb2fd22efc84",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Shein. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "e812e2e1-101f-4050-8e5e-b60c93316f71",
    "store_name": "Shein",
    "store_domain": "shein.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-24",
    "logo": "https://www.google.com/s2/favicons?domain=shein.com&sz=128",
    "created_at": "2025-12-11T11:10:13.563000"
  },
  {
    "id": "0b8abc04-570d-4833-961d-8654464d73f4",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Shein. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "e812e2e1-101f-4050-8e5e-b60c93316f71",
    "store_name": "Shein",
    "store_domain": "shein.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-15",
    "logo": "https://www.google.com/s2/favicons?domain=shein.com&sz=128",
    "created_at": "2025-12-11T11:10:13.563000"
  },
  {
    "id": "284ca804-60ad-4f39-bf76-bf19d77ce08d",
    "title": "Buy 2 Get 1 Free on Select Items",
    "description": "Get 50% off on your purchase at Shein. Shop now and save big!",
    "code": "EXTRA63",
    "discount": "50% OFF",
    "type": "code",
    "store_id": "e812e2e1-101f-4050-8e5e-b60c93316f71",
    "store_name": "Shein",
    "store_domain": "shein.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$5.00",
    "featured": false,
    "expiry_date": "2026-02-21",
    "logo": "https://www.google.com/s2/favicons?domain=shein.com&sz=128",
    "created_at": "2025-12-11T11:10:13.564000"
  },
  {
    "id": "325bf71a-2d56-4363-a418-783b4e7e31bf",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at Boohoo. Shop now and save big!",
    "code": "WELCOMEK35",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "3fced067-fc9f-4a77-ae10-ba4171907f70",
    "store_name": "Boohoo",
    "store_domain": "boohoo.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$22.00",
    "featured": false,
    "expiry_date": "2026-02-13",
    "logo": "https://www.google.com/s2/favicons?domain=boohoo.com&sz=128",
    "created_at": "2025-12-11T11:10:13.565000"
  },
  {
    "id": "a3805735-411a-496d-93ee-6689a3ed75db",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at Boohoo. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "3fced067-fc9f-4a77-ae10-ba4171907f70",
    "store_name": "Boohoo",
    "store_domain": "boohoo.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-17",
    "logo": "https://www.google.com/s2/favicons?domain=boohoo.com&sz=128",
    "created_at": "2025-12-11T11:10:13.566000"
  },
  {
    "id": "86233d90-0ed1-44cb-af6a-be83da0407c9",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at Boohoo. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "3fced067-fc9f-4a77-ae10-ba4171907f70",
    "store_name": "Boohoo",
    "store_domain": "boohoo.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-21",
    "logo": "https://www.google.com/s2/favicons?domain=boohoo.com&sz=128",
    "created_at": "2025-12-11T11:10:13.566000"
  },
  {
    "id": "f9b71e97-457b-481c-8612-1a4cd8eceb3a",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at Boohoo. Shop now and save big!",
    "code": "PQWG85",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "3fced067-fc9f-4a77-ae10-ba4171907f70",
    "store_name": "Boohoo",
    "store_domain": "boohoo.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$11.00",
    "featured": false,
    "expiry_date": "2026-01-03",
    "logo": "https://www.google.com/s2/favicons?domain=boohoo.com&sz=128",
    "created_at": "2025-12-11T11:10:13.566000"
  },
  {
    "id": "80d49ad8-fe34-4d25-b471-627d8dd9a819",
    "title": "$25 off Off Orders $125+",
    "description": "Get $25 off on your purchase at Boohoo. Shop now and save big!",
    "code": null,
    "discount": "$25 OFF",
    "type": "deal",
    "store_id": "3fced067-fc9f-4a77-ae10-ba4171907f70",
    "store_name": "Boohoo",
    "store_domain": "boohoo.com",
    "category": "Sports",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-14",
    "logo": "https://www.google.com/s2/favicons?domain=boohoo.com&sz=128",
    "created_at": "2025-12-11T11:10:13.567000"
  },
  {
    "id": "9a044147-08d9-4e22-a504-3652c0586379",
    "title": "Free Shipping on Orders $150+",
    "description": "Get buy 2 get 1 on your purchase at Boohoo. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "3fced067-fc9f-4a77-ae10-ba4171907f70",
    "store_name": "Boohoo",
    "store_domain": "boohoo.com",
    "category": "Toys",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-19",
    "logo": "https://www.google.com/s2/favicons?domain=boohoo.com&sz=128",
    "created_at": "2025-12-11T11:10:13.567000"
  },
  {
    "id": "c8a177e5-7f94-4315-8dc6-69c092bf651e",
    "title": "Buy 2 Get 1 Free on Select Items",
    "description": "Get 50% off on your purchase at Boohoo. Shop now and save big!",
    "code": "BOO78",
    "discount": "50% OFF",
    "type": "code",
    "store_id": "3fced067-fc9f-4a77-ae10-ba4171907f70",
    "store_name": "Boohoo",
    "store_domain": "boohoo.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$41.00",
    "featured": false,
    "expiry_date": "2026-02-04",
    "logo": "https://www.google.com/s2/favicons?domain=boohoo.com&sz=128",
    "created_at": "2025-12-11T11:10:13.567000"
  },
  {
    "id": "c1a583b9-b6fd-48cc-a550-1f27f8bddfdb",
    "title": "Clearance Sale: Up to $75 off Off",
    "description": "Get $75 off on your purchase at Boohoo. Shop now and save big!",
    "code": null,
    "discount": "$75 OFF",
    "type": "deal",
    "store_id": "3fced067-fc9f-4a77-ae10-ba4171907f70",
    "store_name": "Boohoo",
    "store_domain": "boohoo.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": true,
    "expiry_date": "2026-02-14",
    "logo": "https://www.google.com/s2/favicons?domain=boohoo.com&sz=128",
    "created_at": "2025-12-11T11:10:13.567000"
  },
  {
    "id": "4dd0036f-6472-461c-9820-0ef129b3c9e8",
    "title": "Save 10% off Off Fashion",
    "description": "Get 10% off on your purchase at ASOS. Shop now and save big!",
    "code": "SAVE10",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "03709aa8-a678-44f1-aaa7-f220241ee1e6",
    "store_name": "ASOS",
    "store_domain": "asos.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$31.00",
    "featured": true,
    "expiry_date": "2026-03-11",
    "logo": "https://www.google.com/s2/favicons?domain=asos.com&sz=128",
    "created_at": "2025-12-11T11:10:13.569000"
  },
  {
    "id": "4ddbbf38-8dcc-496a-82bc-dd0cf5e86bc2",
    "title": "Get $10 off Off Your Order",
    "description": "Get $10 off on your purchase at ASOS. Shop now and save big!",
    "code": null,
    "discount": "$10 OFF",
    "type": "deal",
    "store_id": "03709aa8-a678-44f1-aaa7-f220241ee1e6",
    "store_name": "ASOS",
    "store_domain": "asos.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-26",
    "logo": "https://www.google.com/s2/favicons?domain=asos.com&sz=128",
    "created_at": "2025-12-11T11:10:13.569000"
  },
  {
    "id": "2c13fcdf-de1b-497a-b481-b4825db33fdc",
    "title": "buy 2 get 1 Off Sitewide",
    "description": "Get buy 2 get 1 on your purchase at ASOS. Shop now and save big!",
    "code": null,
    "discount": "Buy 2 Get 1",
    "type": "deal",
    "store_id": "03709aa8-a678-44f1-aaa7-f220241ee1e6",
    "store_name": "ASOS",
    "store_domain": "asos.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-01-01",
    "logo": "https://www.google.com/s2/favicons?domain=asos.com&sz=128",
    "created_at": "2025-12-11T11:10:13.569000"
  },
  {
    "id": "a70e68a9-1806-481d-8f46-5fcbe8d359c9",
    "title": "Extra 25% off Off Sale Items",
    "description": "Get 25% off on your purchase at ASOS. Shop now and save big!",
    "code": "ASO39",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "03709aa8-a678-44f1-aaa7-f220241ee1e6",
    "store_name": "ASOS",
    "store_domain": "asos.com",
    "category": "Beauty",
    "verified": false,
    "source": "Generated",
    "savings": "$55.00",
    "featured": false,
    "expiry_date": "2026-01-28",
    "logo": "https://www.google.com/s2/favicons?domain=asos.com&sz=128",
    "created_at": "2025-12-11T11:10:13.570000"
  },
  {
    "id": "330ee170-9940-476b-a921-40c50cc16312",
    "title": "Extra 15% Off Sitewide",
    "description": "Get 15% off on your purchase at Nordstrom. Shop now and save big!",
    "code": "TOP20",
    "discount": "15% OFF",
    "type": "code",
    "store_id": "3af942df-d7d7-4b52-b3f5-fa43fc22d25f",
    "store_name": "Nordstrom",
    "store_domain": "nordstrom.com",
    "category": "Electronics",
    "verified": true,
    "source": "Generated",
    "savings": "$59.00",
    "featured": false,
    "expiry_date": "2026-03-10",
    "logo": "https://www.google.com/s2/favicons?domain=nordstrom.com&sz=128",
    "created_at": "2026-01-14T14:41:38.705Z"
  },
  {
    "id": "ce47d6c0-d360-4e86-bf77-38ca47f51081",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at Nordstrom. Shop now and save big!",
    "code": "EXTRA29",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "3af942df-d7d7-4b52-b3f5-fa43fc22d25f",
    "store_name": "Nordstrom",
    "store_domain": "nordstrom.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$90.00",
    "featured": false,
    "expiry_date": "2026-05-18",
    "logo": "https://www.google.com/s2/favicons?domain=nordstrom.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "3ad1a7be-4163-4f15-ab1c-dd19de778942",
    "title": "Flash Sale: 25% Off Everything",
    "description": "Get 25% off on your purchase at Nordstrom. Shop now and save big!",
    "code": "BEST41",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "3af942df-d7d7-4b52-b3f5-fa43fc22d25f",
    "store_name": "Nordstrom",
    "store_domain": "nordstrom.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$35.00",
    "featured": false,
    "expiry_date": "2026-01-22",
    "logo": "https://www.google.com/s2/favicons?domain=nordstrom.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "94cb452a-bbb0-489f-a1ee-3c643a1b8c5b",
    "title": "$10 Off Orders $50+",
    "description": "Get $10 off on your purchase at Nordstrom. Shop now and save big!",
    "code": "PROMO54",
    "discount": "$10 OFF",
    "type": "code",
    "store_id": "3af942df-d7d7-4b52-b3f5-fa43fc22d25f",
    "store_name": "Nordstrom",
    "store_domain": "nordstrom.com",
    "category": "Beauty",
    "verified": true,
    "source": "Generated",
    "savings": "$87.00",
    "featured": false,
    "expiry_date": "2026-09-19",
    "logo": "https://www.google.com/s2/favicons?domain=nordstrom.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "9dc34257-28c6-457b-af5b-756495ad21dd",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at JCPenney. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "4cfc70d7-ee78-4ab7-b745-335667bcbea8",
    "store_name": "JCPenney",
    "store_domain": "jcpenney.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-04-11",
    "logo": "https://www.google.com/s2/favicons?domain=jcpenney.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "734b52e1-afad-4919-8d3b-cb9c935f0f2c",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at JCPenney. Shop now and save big!",
    "code": "DEAL88",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "4cfc70d7-ee78-4ab7-b745-335667bcbea8",
    "store_name": "JCPenney",
    "store_domain": "jcpenney.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$23.00",
    "featured": false,
    "expiry_date": "2026-08-16",
    "logo": "https://www.google.com/s2/favicons?domain=jcpenney.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "d71bee80-09b9-4fd4-8d6d-9ba742895092",
    "title": "Extra 15% Off Sitewide",
    "description": "Get 15% off on your purchase at JCPenney. Shop now and save big!",
    "code": "DEAL73",
    "discount": "15% OFF",
    "type": "code",
    "store_id": "4cfc70d7-ee78-4ab7-b745-335667bcbea8",
    "store_name": "JCPenney",
    "store_domain": "jcpenney.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": "$82.00",
    "featured": false,
    "expiry_date": "2026-07-22",
    "logo": "https://www.google.com/s2/favicons?domain=jcpenney.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "1f3eb592-31f0-4987-9caa-6e05877f6549",
    "title": "Flash Sale: 25% Off Everything",
    "description": "Get 25% off on your purchase at JCPenney. Shop now and save big!",
    "code": "BEST35",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "4cfc70d7-ee78-4ab7-b745-335667bcbea8",
    "store_name": "JCPenney",
    "store_domain": "jcpenney.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$87.00",
    "featured": false,
    "expiry_date": "2026-05-24",
    "logo": "https://www.google.com/s2/favicons?domain=jcpenney.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "c0daf18a-85a7-4d16-9b89-8575eab21e92",
    "title": "Free Shipping on All Orders",
    "description": "Get free shipping on your purchase at Express. Shop now and save big!",
    "code": null,
    "discount": "Free Shipping",
    "type": "deal",
    "store_id": "d92e9d5a-e25f-466d-ba3e-4647045bf2c7",
    "store_name": "Express",
    "store_domain": "express.com",
    "category": "All",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-03-23",
    "logo": "https://www.google.com/s2/favicons?domain=express.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "e6ab8874-0341-4948-a7cf-ab9dec998ea9",
    "title": "Extra 15% Off Sitewide",
    "description": "Get 15% off on your purchase at Express. Shop now and save big!",
    "code": "TOP28",
    "discount": "15% OFF",
    "type": "code",
    "store_id": "d92e9d5a-e25f-466d-ba3e-4647045bf2c7",
    "store_name": "Express",
    "store_domain": "express.com",
    "category": "Electronics",
    "verified": true,
    "source": "Generated",
    "savings": "$82.00",
    "featured": false,
    "expiry_date": "2026-07-15",
    "logo": "https://www.google.com/s2/favicons?domain=express.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "526e446b-1693-4354-bed7-1a7869b5ba6d",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at Express. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "d92e9d5a-e25f-466d-ba3e-4647045bf2c7",
    "store_name": "Express",
    "store_domain": "express.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-25",
    "logo": "https://www.google.com/s2/favicons?domain=express.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "695db483-b671-4d39-8cdb-497a15606357",
    "title": "Flash Sale: 25% Off Everything",
    "description": "Get 25% off on your purchase at PacSun. Shop now and save big!",
    "code": "TOP70",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "edd95cc1-3989-46e2-b860-1a91990451ba",
    "store_name": "PacSun",
    "store_domain": "pacsun.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$53.00",
    "featured": false,
    "expiry_date": "2026-05-18",
    "logo": "https://www.google.com/s2/favicons?domain=pacsun.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "8cbb005b-409a-499c-936e-4ec64a192af8",
    "title": "Extra 15% Off Sitewide",
    "description": "Get 15% off on your purchase at PacSun. Shop now and save big!",
    "code": "MEGA34",
    "discount": "15% OFF",
    "type": "code",
    "store_id": "edd95cc1-3989-46e2-b860-1a91990451ba",
    "store_name": "PacSun",
    "store_domain": "pacsun.com",
    "category": "Electronics",
    "verified": false,
    "source": "Generated",
    "savings": "$57.00",
    "featured": false,
    "expiry_date": "2026-04-12",
    "logo": "https://www.google.com/s2/favicons?domain=pacsun.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "817b2abb-e754-4a0b-ad60-c7deb0e0dd6b",
    "title": "Free Shipping on All Orders",
    "description": "Get free shipping on your purchase at PacSun. Shop now and save big!",
    "code": null,
    "discount": "Free Shipping",
    "type": "deal",
    "store_id": "edd95cc1-3989-46e2-b860-1a91990451ba",
    "store_name": "PacSun",
    "store_domain": "pacsun.com",
    "category": "All",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-04-27",
    "logo": "https://www.google.com/s2/favicons?domain=pacsun.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "fc2f98ff-40a2-48f0-817c-0ca424ff50ee",
    "title": "$10 Off Orders $50+",
    "description": "Get $10 off on your purchase at PacSun. Shop now and save big!",
    "code": "SHOP47",
    "discount": "$10 OFF",
    "type": "code",
    "store_id": "edd95cc1-3989-46e2-b860-1a91990451ba",
    "store_name": "PacSun",
    "store_domain": "pacsun.com",
    "category": "Beauty",
    "verified": true,
    "source": "Generated",
    "savings": "$42.00",
    "featured": false,
    "expiry_date": "2026-08-19",
    "logo": "https://www.google.com/s2/favicons?domain=pacsun.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "fead30d7-5f5c-4dda-97bf-48b43cac5ea0",
    "title": "Get 20% Off Your Purchase",
    "description": "Get 20% off on your purchase at Topshop. Shop now and save big!",
    "code": "PROMO47",
    "discount": "20% OFF",
    "type": "code",
    "store_id": "2601effc-dd23-41ef-b9bb-3757fd579eec",
    "store_name": "Topshop",
    "store_domain": "topshop.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": "$69.00",
    "featured": false,
    "expiry_date": "2026-05-28",
    "logo": "https://www.google.com/s2/favicons?domain=topshop.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "8772e023-cca4-4700-b2be-d5c1d329d247",
    "title": "Flash Sale: 25% Off Everything",
    "description": "Get 25% off on your purchase at Topshop. Shop now and save big!",
    "code": "SHOP35",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "2601effc-dd23-41ef-b9bb-3757fd579eec",
    "store_name": "Topshop",
    "store_domain": "topshop.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$31.00",
    "featured": false,
    "expiry_date": "2026-05-29",
    "logo": "https://www.google.com/s2/favicons?domain=topshop.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "45365075-48b9-4eb9-8bc7-88439c440c9d",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at Topshop. Shop now and save big!",
    "code": "SAVE72",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "2601effc-dd23-41ef-b9bb-3757fd579eec",
    "store_name": "Topshop",
    "store_domain": "topshop.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$21.00",
    "featured": false,
    "expiry_date": "2026-04-28",
    "logo": "https://www.google.com/s2/favicons?domain=topshop.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "0913890a-bb6d-4890-b85d-a681088f73a7",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at Topshop. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "2601effc-dd23-41ef-b9bb-3757fd579eec",
    "store_name": "Topshop",
    "store_domain": "topshop.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-07-24",
    "logo": "https://www.google.com/s2/favicons?domain=topshop.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "265392ab-0566-48c7-9c1d-2b73714be56b",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at Zales. Shop now and save big!",
    "code": "BEST32",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "a53bcc67-349a-4a42-a777-bff12a934a45",
    "store_name": "Zales",
    "store_domain": "zales.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$72.00",
    "featured": false,
    "expiry_date": "2026-05-13",
    "logo": "https://www.google.com/s2/favicons?domain=zales.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "dc7fc8df-e3ed-4d65-91ce-59163e1a0193",
    "title": "Get 20% Off Your Purchase",
    "description": "Get 20% off on your purchase at Zales. Shop now and save big!",
    "code": "SUPER24",
    "discount": "20% OFF",
    "type": "code",
    "store_id": "a53bcc67-349a-4a42-a777-bff12a934a45",
    "store_name": "Zales",
    "store_domain": "zales.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": "$82.00",
    "featured": false,
    "expiry_date": "2026-07-17",
    "logo": "https://www.google.com/s2/favicons?domain=zales.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "8d4dbee9-9cef-4fe9-8bef-030959f431a3",
    "title": "Extra 15% Off Sitewide",
    "description": "Get 15% off on your purchase at Zales. Shop now and save big!",
    "code": "MEGA93",
    "discount": "15% OFF",
    "type": "code",
    "store_id": "a53bcc67-349a-4a42-a777-bff12a934a45",
    "store_name": "Zales",
    "store_domain": "zales.com",
    "category": "Electronics",
    "verified": true,
    "source": "Generated",
    "savings": "$87.00",
    "featured": false,
    "expiry_date": "2026-07-28",
    "logo": "https://www.google.com/s2/favicons?domain=zales.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "7d3a2ee0-bb9f-4e33-b854-aad3d8c43056",
    "title": "Free Shipping on All Orders",
    "description": "Get free shipping on your purchase at Zales. Shop now and save big!",
    "code": null,
    "discount": "Free Shipping",
    "type": "deal",
    "store_id": "a53bcc67-349a-4a42-a777-bff12a934a45",
    "store_name": "Zales",
    "store_domain": "zales.com",
    "category": "All",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-06-27",
    "logo": "https://www.google.com/s2/favicons?domain=zales.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "ebf74f17-66c5-45a1-b9bf-21d0970ef0c1",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at Zales. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "a53bcc67-349a-4a42-a777-bff12a934a45",
    "store_name": "Zales",
    "store_domain": "zales.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-04-24",
    "logo": "https://www.google.com/s2/favicons?domain=zales.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "337a30f1-e4cb-4101-b06e-6889eaf2de95",
    "title": "Flash Sale: 25% Off Everything",
    "description": "Get 25% off on your purchase at Victoria's Secret. Shop now and save big!",
    "code": "BEST51",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "279c9cd2-d0d0-46fa-b007-16695d9fd717",
    "store_name": "Victoria's Secret",
    "store_domain": "victoriassecret.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$84.00",
    "featured": false,
    "expiry_date": "2026-07-13",
    "logo": "https://www.google.com/s2/favicons?domain=victoriassecret.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "ab054f2f-60b9-47e4-94e0-301c7d591ff8",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at Victoria's Secret. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "279c9cd2-d0d0-46fa-b007-16695d9fd717",
    "store_name": "Victoria's Secret",
    "store_domain": "victoriassecret.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-09-25",
    "logo": "https://www.google.com/s2/favicons?domain=victoriassecret.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "da024711-87da-4bc7-8ea5-46e5c0806b17",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at Victoria's Secret. Shop now and save big!",
    "code": "SUPER87",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "279c9cd2-d0d0-46fa-b007-16695d9fd717",
    "store_name": "Victoria's Secret",
    "store_domain": "victoriassecret.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$62.00",
    "featured": false,
    "expiry_date": "2026-09-14",
    "logo": "https://www.google.com/s2/favicons?domain=victoriassecret.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "916d5ca4-e13b-43b2-95b2-d505d6b99a4d",
    "title": "Get 20% Off Your Purchase",
    "description": "Get 20% off on your purchase at Victoria's Secret. Shop now and save big!",
    "code": "GET65",
    "discount": "20% OFF",
    "type": "code",
    "store_id": "279c9cd2-d0d0-46fa-b007-16695d9fd717",
    "store_name": "Victoria's Secret",
    "store_domain": "victoriassecret.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": "$43.00",
    "featured": false,
    "expiry_date": "2026-03-23",
    "logo": "https://www.google.com/s2/favicons?domain=victoriassecret.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "67504915-eb64-43fb-97f5-76dd7ca16df8",
    "title": "$25 Off Orders $100+",
    "description": "Get $25 off on your purchase at Victoria's Secret. Shop now and save big!",
    "code": "DEAL74",
    "discount": "$25 OFF",
    "type": "code",
    "store_id": "279c9cd2-d0d0-46fa-b007-16695d9fd717",
    "store_name": "Victoria's Secret",
    "store_domain": "victoriassecret.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$22.00",
    "featured": false,
    "expiry_date": "2026-07-24",
    "logo": "https://www.google.com/s2/favicons?domain=victoriassecret.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "3d06d2d9-9e6e-46ed-8064-8556674e2183",
    "title": "Get 20% Off Your Purchase",
    "description": "Get 20% off on your purchase at Foot Locker. Shop now and save big!",
    "code": "EXTRA44",
    "discount": "20% OFF",
    "type": "code",
    "store_id": "c1b6af5e-6e28-483e-b626-5e2433305578",
    "store_name": "Foot Locker",
    "store_domain": "footlocker.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": "$34.00",
    "featured": false,
    "expiry_date": "2026-04-25",
    "logo": "https://www.google.com/s2/favicons?domain=footlocker.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "b0ddd608-196a-47f2-bc72-00cb510b6743",
    "title": "$10 Off Orders $50+",
    "description": "Get $10 off on your purchase at Foot Locker. Shop now and save big!",
    "code": "PROMO14",
    "discount": "$10 OFF",
    "type": "code",
    "store_id": "c1b6af5e-6e28-483e-b626-5e2433305578",
    "store_name": "Foot Locker",
    "store_domain": "footlocker.com",
    "category": "Beauty",
    "verified": true,
    "source": "Generated",
    "savings": "$70.00",
    "featured": false,
    "expiry_date": "2026-09-27",
    "logo": "https://www.google.com/s2/favicons?domain=footlocker.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "0b8a4bda-23b6-437a-82c7-5820d738e3dc",
    "title": "Extra 15% Off Sitewide",
    "description": "Get 15% off on your purchase at Foot Locker. Shop now and save big!",
    "code": "EXTRA80",
    "discount": "15% OFF",
    "type": "code",
    "store_id": "c1b6af5e-6e28-483e-b626-5e2433305578",
    "store_name": "Foot Locker",
    "store_domain": "footlocker.com",
    "category": "Electronics",
    "verified": true,
    "source": "Generated",
    "savings": "$90.00",
    "featured": false,
    "expiry_date": "2026-09-17",
    "logo": "https://www.google.com/s2/favicons?domain=footlocker.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "ad8eddb6-2df8-4e4b-9f0e-d7ce0ab2283e",
    "title": "Get 20% Off Your Purchase",
    "description": "Get 20% off on your purchase at Finish Line. Shop now and save big!",
    "code": "SHOP45",
    "discount": "20% OFF",
    "type": "code",
    "store_id": "31a683d9-3763-45a4-885a-1d29253f8ad0",
    "store_name": "Finish Line",
    "store_domain": "finishline.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": "$41.00",
    "featured": false,
    "expiry_date": "2026-07-24",
    "logo": "https://www.google.com/s2/favicons?domain=finishline.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "976aaa6c-1718-4221-8384-16a151dec8bc",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at Finish Line. Shop now and save big!",
    "code": "EXTRA20",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "31a683d9-3763-45a4-885a-1d29253f8ad0",
    "store_name": "Finish Line",
    "store_domain": "finishline.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$93.00",
    "featured": false,
    "expiry_date": "2026-06-18",
    "logo": "https://www.google.com/s2/favicons?domain=finishline.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "0903aea9-60ff-41f0-8d44-5b2ea9029048",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at Finish Line. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "31a683d9-3763-45a4-885a-1d29253f8ad0",
    "store_name": "Finish Line",
    "store_domain": "finishline.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-22",
    "logo": "https://www.google.com/s2/favicons?domain=finishline.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "37226617-5d6b-4e72-a572-9dcca312ee42",
    "title": "$25 Off Orders $100+",
    "description": "Get $25 off on your purchase at Vans. Shop now and save big!",
    "code": "DEAL17",
    "discount": "$25 OFF",
    "type": "code",
    "store_id": "d6a34cd5-e815-446f-af73-35e1343a2172",
    "store_name": "Vans",
    "store_domain": "vans.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$41.00",
    "featured": false,
    "expiry_date": "2026-04-19",
    "logo": "https://www.google.com/s2/favicons?domain=vans.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "242022e8-a2e9-4bbf-b742-7aea2ab6da62",
    "title": "$10 Off Orders $50+",
    "description": "Get $10 off on your purchase at Vans. Shop now and save big!",
    "code": "EXTRA20",
    "discount": "$10 OFF",
    "type": "code",
    "store_id": "d6a34cd5-e815-446f-af73-35e1343a2172",
    "store_name": "Vans",
    "store_domain": "vans.com",
    "category": "Beauty",
    "verified": true,
    "source": "Generated",
    "savings": "$57.00",
    "featured": false,
    "expiry_date": "2026-08-16",
    "logo": "https://www.google.com/s2/favicons?domain=vans.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "fb80f247-86e0-4bd9-8906-259fd1c1a294",
    "title": "Get 20% Off Your Purchase",
    "description": "Get 20% off on your purchase at Vans. Shop now and save big!",
    "code": "MEGA54",
    "discount": "20% OFF",
    "type": "code",
    "store_id": "d6a34cd5-e815-446f-af73-35e1343a2172",
    "store_name": "Vans",
    "store_domain": "vans.com",
    "category": "Home",
    "verified": false,
    "source": "Generated",
    "savings": "$52.00",
    "featured": false,
    "expiry_date": "2026-03-17",
    "logo": "https://www.google.com/s2/favicons?domain=vans.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "617fb257-891b-43ad-abba-d0ab3a2c9df5",
    "title": "Get 20% Off Your Purchase",
    "description": "Get 20% off on your purchase at Reebok. Shop now and save big!",
    "code": "SHOP68",
    "discount": "20% OFF",
    "type": "code",
    "store_id": "f60cc4e1-4dfe-463b-b043-586e06edf19a",
    "store_name": "Reebok",
    "store_domain": "reebok.com",
    "category": "Home",
    "verified": false,
    "source": "Generated",
    "savings": "$33.00",
    "featured": false,
    "expiry_date": "2026-05-14",
    "logo": "https://www.google.com/s2/favicons?domain=reebok.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "8ecf80a4-63de-4d10-8269-5e869a226736",
    "title": "$25 Off Orders $100+",
    "description": "Get $25 off on your purchase at Reebok. Shop now and save big!",
    "code": "SAVE13",
    "discount": "$25 OFF",
    "type": "code",
    "store_id": "f60cc4e1-4dfe-463b-b043-586e06edf19a",
    "store_name": "Reebok",
    "store_domain": "reebok.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$41.00",
    "featured": false,
    "expiry_date": "2026-02-21",
    "logo": "https://www.google.com/s2/favicons?domain=reebok.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "60f188b8-2167-42c5-8acd-43b57bb4fcca",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at Reebok. Shop now and save big!",
    "code": "MEGA97",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "f60cc4e1-4dfe-463b-b043-586e06edf19a",
    "store_name": "Reebok",
    "store_domain": "reebok.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$21.00",
    "featured": false,
    "expiry_date": "2026-08-16",
    "logo": "https://www.google.com/s2/favicons?domain=reebok.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "49648c2e-e35d-4f0f-af45-4cfe7eb2ba99",
    "title": "$10 Off Orders $50+",
    "description": "Get $10 off on your purchase at Reebok. Shop now and save big!",
    "code": "PROMO77",
    "discount": "$10 OFF",
    "type": "code",
    "store_id": "f60cc4e1-4dfe-463b-b043-586e06edf19a",
    "store_name": "Reebok",
    "store_domain": "reebok.com",
    "category": "Beauty",
    "verified": true,
    "source": "Generated",
    "savings": "$84.00",
    "featured": false,
    "expiry_date": "2026-07-16",
    "logo": "https://www.google.com/s2/favicons?domain=reebok.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "e0405ae7-5d7f-403a-aad4-f1aae34844b1",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at Reebok. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "f60cc4e1-4dfe-463b-b043-586e06edf19a",
    "store_name": "Reebok",
    "store_domain": "reebok.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-09-20",
    "logo": "https://www.google.com/s2/favicons?domain=reebok.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "37f0d328-26a7-4119-a12b-2bfc8a29fabc",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at Puma. Shop now and save big!",
    "code": "SHOP40",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "6e3109c1-ef9a-4d38-82ee-862267c8d983",
    "store_name": "Puma",
    "store_domain": "puma.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$40.00",
    "featured": false,
    "expiry_date": "2026-09-14",
    "logo": "https://www.google.com/s2/favicons?domain=puma.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "519e8dd3-050d-4b79-9253-f55aafbaa3f9",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at Puma. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "6e3109c1-ef9a-4d38-82ee-862267c8d983",
    "store_name": "Puma",
    "store_domain": "puma.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-07-10",
    "logo": "https://www.google.com/s2/favicons?domain=puma.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "051c5955-b077-4558-94ed-94f8e060348c",
    "title": "Extra 15% Off Sitewide",
    "description": "Get 15% off on your purchase at Puma. Shop now and save big!",
    "code": "DEAL19",
    "discount": "15% OFF",
    "type": "code",
    "store_id": "6e3109c1-ef9a-4d38-82ee-862267c8d983",
    "store_name": "Puma",
    "store_domain": "puma.com",
    "category": "Electronics",
    "verified": true,
    "source": "Generated",
    "savings": "$60.00",
    "featured": false,
    "expiry_date": "2026-06-19",
    "logo": "https://www.google.com/s2/favicons?domain=puma.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "c569e24c-5eb0-4e27-977c-705cbf2009ea",
    "title": "$10 Off Orders $50+",
    "description": "Get $10 off on your purchase at Puma. Shop now and save big!",
    "code": "BEST82",
    "discount": "$10 OFF",
    "type": "code",
    "store_id": "6e3109c1-ef9a-4d38-82ee-862267c8d983",
    "store_name": "Puma",
    "store_domain": "puma.com",
    "category": "Beauty",
    "verified": true,
    "source": "Generated",
    "savings": "$76.00",
    "featured": false,
    "expiry_date": "2026-09-19",
    "logo": "https://www.google.com/s2/favicons?domain=puma.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "babb0e52-ea63-4fc1-9232-d257d0bb45ae",
    "title": "Get 20% Off Your Purchase",
    "description": "Get 20% off on your purchase at New Balance. Shop now and save big!",
    "code": "MEGA25",
    "discount": "20% OFF",
    "type": "code",
    "store_id": "cfeda609-045f-489c-8242-b7064fcd449c",
    "store_name": "New Balance",
    "store_domain": "newbalance.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": "$77.00",
    "featured": false,
    "expiry_date": "2026-07-23",
    "logo": "https://www.google.com/s2/favicons?domain=newbalance.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "a6d241db-76a0-4e19-9c20-d8ae48bf0b95",
    "title": "$25 Off Orders $100+",
    "description": "Get $25 off on your purchase at New Balance. Shop now and save big!",
    "code": "GET55",
    "discount": "$25 OFF",
    "type": "code",
    "store_id": "cfeda609-045f-489c-8242-b7064fcd449c",
    "store_name": "New Balance",
    "store_domain": "newbalance.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$29.00",
    "featured": false,
    "expiry_date": "2026-09-25",
    "logo": "https://www.google.com/s2/favicons?domain=newbalance.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "5ee561ee-3892-4f17-a9c1-146247f7f415",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at New Balance. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "cfeda609-045f-489c-8242-b7064fcd449c",
    "store_name": "New Balance",
    "store_domain": "newbalance.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-02-27",
    "logo": "https://www.google.com/s2/favicons?domain=newbalance.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "2a1645a9-0c66-4f23-a838-da967ec21fb9",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at New Balance. Shop now and save big!",
    "code": "GET63",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "cfeda609-045f-489c-8242-b7064fcd449c",
    "store_name": "New Balance",
    "store_domain": "newbalance.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$73.00",
    "featured": false,
    "expiry_date": "2026-06-23",
    "logo": "https://www.google.com/s2/favicons?domain=newbalance.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "1221cea7-f657-44a1-a8ff-57344601b97c",
    "title": "$10 Off Orders $50+",
    "description": "Get $10 off on your purchase at New Balance. Shop now and save big!",
    "code": "EXTRA31",
    "discount": "$10 OFF",
    "type": "code",
    "store_id": "cfeda609-045f-489c-8242-b7064fcd449c",
    "store_name": "New Balance",
    "store_domain": "newbalance.com",
    "category": "Beauty",
    "verified": true,
    "source": "Generated",
    "savings": "$20.00",
    "featured": false,
    "expiry_date": "2026-05-17",
    "logo": "https://www.google.com/s2/favicons?domain=newbalance.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "23427255-4f90-4df4-b3cd-a5cb7c84f1f4",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at Calvin Klein. Shop now and save big!",
    "code": "BEST15",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "4d87c189-d440-4f97-9618-92b8af65ff41",
    "store_name": "Calvin Klein",
    "store_domain": "calvinklein.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$38.00",
    "featured": false,
    "expiry_date": "2026-05-10",
    "logo": "https://www.google.com/s2/favicons?domain=calvinklein.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "185beac0-d7a8-43f4-84f2-f01ae69f97ba",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at Calvin Klein. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "4d87c189-d440-4f97-9618-92b8af65ff41",
    "store_name": "Calvin Klein",
    "store_domain": "calvinklein.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-05-26",
    "logo": "https://www.google.com/s2/favicons?domain=calvinklein.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "549baa9e-524e-424c-87e9-9a584b109e08",
    "title": "Flash Sale: 25% Off Everything",
    "description": "Get 25% off on your purchase at Calvin Klein. Shop now and save big!",
    "code": "SAVE93",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "4d87c189-d440-4f97-9618-92b8af65ff41",
    "store_name": "Calvin Klein",
    "store_domain": "calvinklein.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$51.00",
    "featured": false,
    "expiry_date": "2026-04-21",
    "logo": "https://www.google.com/s2/favicons?domain=calvinklein.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "2d375599-99b9-4acc-8f04-73f503bbc406",
    "title": "$25 Off Orders $100+",
    "description": "Get $25 off on your purchase at Calvin Klein. Shop now and save big!",
    "code": "SHOP60",
    "discount": "$25 OFF",
    "type": "code",
    "store_id": "4d87c189-d440-4f97-9618-92b8af65ff41",
    "store_name": "Calvin Klein",
    "store_domain": "calvinklein.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$79.00",
    "featured": false,
    "expiry_date": "2026-08-27",
    "logo": "https://www.google.com/s2/favicons?domain=calvinklein.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "5e30e162-4b13-4684-9771-9e65abd32ac1",
    "title": "Get 20% Off Your Purchase",
    "description": "Get 20% off on your purchase at Tommy Hilfiger. Shop now and save big!",
    "code": "TOP19",
    "discount": "20% OFF",
    "type": "code",
    "store_id": "4e7ea571-999d-4d10-989f-207c2dd8e6e6",
    "store_name": "Tommy Hilfiger",
    "store_domain": "tommy.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": "$91.00",
    "featured": false,
    "expiry_date": "2026-02-13",
    "logo": "https://www.google.com/s2/favicons?domain=tommy.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "9d48850b-6d2d-4606-8c46-0534c083945d",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at Tommy Hilfiger. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "4e7ea571-999d-4d10-989f-207c2dd8e6e6",
    "store_name": "Tommy Hilfiger",
    "store_domain": "tommy.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-09-16",
    "logo": "https://www.google.com/s2/favicons?domain=tommy.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "ebf71633-41d5-4ad7-a576-4b6fb5d56dbb",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at Tommy Hilfiger. Shop now and save big!",
    "code": "EXTRA57",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "4e7ea571-999d-4d10-989f-207c2dd8e6e6",
    "store_name": "Tommy Hilfiger",
    "store_domain": "tommy.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$21.00",
    "featured": false,
    "expiry_date": "2026-03-24",
    "logo": "https://www.google.com/s2/favicons?domain=tommy.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "ecbc01d2-c603-496b-b270-f7de31b17c0e",
    "title": "Get 20% Off Your Purchase",
    "description": "Get 20% off on your purchase at Ralph Lauren. Shop now and save big!",
    "code": "DEAL17",
    "discount": "20% OFF",
    "type": "code",
    "store_id": "bd60d6cd-66e3-498d-a3ba-1bf7c45a2646",
    "store_name": "Ralph Lauren",
    "store_domain": "ralphlauren.com",
    "category": "Home",
    "verified": true,
    "source": "Generated",
    "savings": "$21.00",
    "featured": false,
    "expiry_date": "2026-06-20",
    "logo": "https://www.google.com/s2/favicons?domain=ralphlauren.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "f025586b-723b-4492-be43-19cabd24e4c4",
    "title": "Flash Sale: 25% Off Everything",
    "description": "Get 25% off on your purchase at Ralph Lauren. Shop now and save big!",
    "code": "PROMO22",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "bd60d6cd-66e3-498d-a3ba-1bf7c45a2646",
    "store_name": "Ralph Lauren",
    "store_domain": "ralphlauren.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$45.00",
    "featured": false,
    "expiry_date": "2026-06-28",
    "logo": "https://www.google.com/s2/favicons?domain=ralphlauren.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "71e8af87-0349-4edd-a801-cd22e186aefb",
    "title": "$10 Off Orders $50+",
    "description": "Get $10 off on your purchase at Ralph Lauren. Shop now and save big!",
    "code": "GET24",
    "discount": "$10 OFF",
    "type": "code",
    "store_id": "bd60d6cd-66e3-498d-a3ba-1bf7c45a2646",
    "store_name": "Ralph Lauren",
    "store_domain": "ralphlauren.com",
    "category": "Beauty",
    "verified": true,
    "source": "Generated",
    "savings": "$32.00",
    "featured": false,
    "expiry_date": "2026-07-13",
    "logo": "https://www.google.com/s2/favicons?domain=ralphlauren.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "73a17a5d-daf2-4d1c-ae8a-1f2631bbd492",
    "title": "Extra 15% Off Sitewide",
    "description": "Get 15% off on your purchase at Guess. Shop now and save big!",
    "code": "SHOP55",
    "discount": "15% OFF",
    "type": "code",
    "store_id": "6a244039-b711-416a-8f12-318b575f84df",
    "store_name": "Guess",
    "store_domain": "guess.com",
    "category": "Electronics",
    "verified": true,
    "source": "Generated",
    "savings": "$45.00",
    "featured": false,
    "expiry_date": "2026-05-12",
    "logo": "https://www.google.com/s2/favicons?domain=guess.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "1a5680e6-1718-473c-b5c4-1ed3a7b1733e",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at Guess. Shop now and save big!",
    "code": "EXTRA60",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "6a244039-b711-416a-8f12-318b575f84df",
    "store_name": "Guess",
    "store_domain": "guess.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$82.00",
    "featured": false,
    "expiry_date": "2026-08-28",
    "logo": "https://www.google.com/s2/favicons?domain=guess.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "320f5b3f-81aa-443d-b303-3b4aa1467fc1",
    "title": "Buy One Get One Free",
    "description": "Get buy 1 get 1 on your purchase at Guess. Shop now and save big!",
    "code": null,
    "discount": "Buy 1 Get 1",
    "type": "deal",
    "store_id": "6a244039-b711-416a-8f12-318b575f84df",
    "store_name": "Guess",
    "store_domain": "guess.com",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": null,
    "featured": false,
    "expiry_date": "2026-04-15",
    "logo": "https://www.google.com/s2/favicons?domain=guess.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "b5432cf2-c99a-46b0-be2a-16b1e3ce934b",
    "title": "Flash Sale: 25% Off Everything",
    "description": "Get 25% off on your purchase at Guess. Shop now and save big!",
    "code": "DEAL82",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "6a244039-b711-416a-8f12-318b575f84df",
    "store_name": "Guess",
    "store_domain": "guess.com",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$85.00",
    "featured": false,
    "expiry_date": "2026-05-16",
    "logo": "https://www.google.com/s2/favicons?domain=guess.com&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "4a5f53b2-482c-44e2-9741-7f791c818d70",
    "title": "$25 Off Orders $100+",
    "description": "Get $25 off on your purchase at Mey & Edlich. Shop now and save big!",
    "code": "SUPER33",
    "discount": "$25 OFF",
    "type": "code",
    "store_id": "6d7c3a37-df56-4489-8ff5-94e7382e4d09",
    "store_name": "Mey & Edlich",
    "store_domain": "www.mey-edlich.de",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$96.00",
    "featured": false,
    "expiry_date": "2026-05-23",
    "logo": "https://www.google.com/s2/favicons?domain=www.mey-edlich.de&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "df763cc0-f7e9-4e6d-acc7-b656a3662c15",
    "title": "Flash Sale: 25% Off Everything",
    "description": "Get 25% off on your purchase at Mey & Edlich. Shop now and save big!",
    "code": "SUPER63",
    "discount": "25% OFF",
    "type": "code",
    "store_id": "6d7c3a37-df56-4489-8ff5-94e7382e4d09",
    "store_name": "Mey & Edlich",
    "store_domain": "www.mey-edlich.de",
    "category": "Fashion",
    "verified": true,
    "source": "Generated",
    "savings": "$59.00",
    "featured": false,
    "expiry_date": "2026-02-10",
    "logo": "https://www.google.com/s2/favicons?domain=www.mey-edlich.de&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  },
  {
    "id": "f1107d78-b4f6-4256-87e2-fffef12afe9f",
    "title": "Save 10% on Your Order",
    "description": "Get 10% off on your purchase at Mey & Edlich. Shop now and save big!",
    "code": "DEAL85",
    "discount": "10% OFF",
    "type": "code",
    "store_id": "6d7c3a37-df56-4489-8ff5-94e7382e4d09",
    "store_name": "Mey & Edlich",
    "store_domain": "www.mey-edlich.de",
    "category": "Fashion",
    "verified": false,
    "source": "Generated",
    "savings": "$66.00",
    "featured": false,
    "expiry_date": "2026-07-16",
    "logo": "https://www.google.com/s2/favicons?domain=www.mey-edlich.de&sz=128",
    "created_at": "2026-01-14T14:41:38.706Z"
  }
];
